/* Speakeasy Moonshine – Shop-Verhalten wie im Next.js-Shop, aber mit dem Shopify-Warenkorb (Ajax Cart API). */
(function () {
  'use strict';

  var S = window.SPEAKEASY || { produkte: {}, anzahlSorten: 4, versandkosten: 790, gratisAb: 10000 };
  var $ = function (sel, el) { return (el || document).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); };
  var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var euro = function (cent) { return (cent / 100).toFixed(2).replace('.', ',') + ' €'; };
  var esc = function (t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var speicher = {
    lies: function (k, f) { try { var v = localStorage.getItem(k); return v === null ? f : JSON.parse(v); } catch (e) { return f; } },
    schreibe: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };

  /* ---------- Hinweise (wie Hinweise.tsx) ---------- */
  function hinweis(text, typ) {
    var box = $('[data-hinweise]');
    if (!box) return;
    var fehler = typ === 'fehler';
    var el = document.createElement('button');
    el.type = 'button';
    el.className = 'animate-fadeIn rounded-xl border bg-[#181a24] px-4 py-3 text-left text-xs font-semibold shadow-2xl ' +
      (fehler ? 'border-red-500/50 text-red-300' : 'border-amber-400/40 text-amber-200');
    el.textContent = (fehler ? '⚠️ ' : '✓ ') + text;
    el.addEventListener('click', function () { el.remove(); });
    box.appendChild(el);
    while (box.children.length > 3) box.firstChild.remove();
    setTimeout(function () { el.remove(); }, 4000);
  }

  /* ---------- Scrollen sperren, solange ein Overlay offen ist ---------- */
  function scrollSperre() {
    var offen = $$('[data-warenkorb-leiste], [data-mixbox], [data-bildansicht], [data-altersabfrage], [data-jagd-dialog], [data-jagd-sieg], [data-hinterzimmer], [data-rezept]').some(function (el) { return !el.hidden; });
    document.body.style.overflow = offen ? 'hidden' : '';
  }
  function zeige(el, sichtbar) { if (el) { el.hidden = !sichtbar; scrollSperre(); } }

  /* ---------- Knöpfe: Lichtwelle vom Klickpunkt aus, Pfeile die mitgehen ---------- */
  document.addEventListener('pointerdown', function (e) {
    var k = e.target.closest && e.target.closest('.btn-primary, a.bg-amber-400, button.bg-amber-400, .sel-inactive, .sel-active');
    if (!k || k.disabled || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var r = k.getBoundingClientRect(), d = Math.max(r.width, r.height) * 2.2;
    var w = document.createElement('span');
    w.className = 'knopf-welle';
    w.setAttribute('aria-hidden', 'true');
    w.style.cssText = 'width:' + d + 'px;height:' + d + 'px;left:' + (e.clientX - r.left - d / 2) + 'px;top:' + (e.clientY - r.top - d / 2) + 'px';
    k.appendChild(w);
    setTimeout(function () { w.remove(); }, 700);
  });
  $$('a, button').forEach(function (el) {
    var letzter = el.lastChild, erster = el.firstChild, s;
    if (letzter && letzter.nodeType === 3 && /→\s*$/.test(letzter.nodeValue)) {
      letzter.nodeValue = letzter.nodeValue.replace(/\s*→\s*$/, ' ');
      s = document.createElement('span'); s.className = 'pfeil'; s.setAttribute('aria-hidden', 'true'); s.textContent = '→'; el.appendChild(s);
    }
    if (erster && erster.nodeType === 3 && /^\s*←/.test(erster.nodeValue)) {
      erster.nodeValue = erster.nodeValue.replace(/^\s*←\s*/, ' ');
      s = document.createElement('span'); s.className = 'pfeil pfeil-zurueck'; s.setAttribute('aria-hidden', 'true'); s.textContent = '←'; el.insertBefore(s, el.firstChild);
    }
  });

  /* ---------- Hell/Dunkel ---------- */
  $$('[data-design-umschalten]').forEach(function (b) {
    b.addEventListener('click', function () {
      var wurzelEl = document.documentElement;
      var hell = wurzelEl.dataset.theme !== 'light';
      var umschalten = function () {
        if (hell) wurzelEl.dataset.theme = 'light'; else delete wurzelEl.dataset.theme;
        try { localStorage.setItem('speakeasy_theme', hell ? 'light' : 'dark'); } catch (e) {}
      };
      // Neuer Modus breitet sich als Kreis vom Knopf über die ganze Seite aus (wo der Browser das kann, sonst sofort)
      var stillHalten = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!document.startViewTransition || stillHalten) { umschalten(); return; }
      var r = b.getBoundingClientRect(), x = r.left + r.width / 2, y = r.top + r.height / 2;
      var radius = Math.hypot(Math.max(x, window.innerWidth - x), Math.max(y, window.innerHeight - y));
      wurzelEl.classList.add('modus-wechsel');
      var wechsel = document.startViewTransition(umschalten);
      wechsel.ready.then(function () {
        wurzelEl.animate({ clipPath: ['circle(0px at ' + x + 'px ' + y + 'px)', 'circle(' + radius + 'px at ' + x + 'px ' + y + 'px)'] },
          { duration: 700, easing: 'cubic-bezier(.65,0,.35,1)', pseudoElement: '::view-transition-new(root)' });
      }).catch(function () {});
      wechsel.finished.then(function () { wurzelEl.classList.remove('modus-wechsel'); }, function () { wurzelEl.classList.remove('modus-wechsel'); });
    });
  });

  /* ---------- Menü ---------- */
  var menueKnopf = $('[data-menue-umschalten]');
  var menue = $('#hauptnavigation');
  if (menueKnopf && menue) {
    menueKnopf.addEventListener('click', function () {
      var auf = menue.hidden;
      menue.hidden = !auf;
      menueKnopf.setAttribute('aria-expanded', String(auf));
      menueKnopf.setAttribute('aria-label', auf ? 'Menü schließen' : 'Menü öffnen');
    });
    // Tippen außerhalb oder auf einen Link (z. B. Sprung auf der Startseite) schließt das Menü
    document.addEventListener('click', function (e) {
      if (menue.hidden || menueKnopf.contains(e.target) || (menue.contains(e.target) && !e.target.closest('a'))) return;
      menue.hidden = true;
      menueKnopf.setAttribute('aria-expanded', 'false');
      menueKnopf.setAttribute('aria-label', 'Menü öffnen');
    });
  }

  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Kopfleiste: beim Runterscrollen weg, sobald man wieder hochscrollt, sofort da ---------- */
  var kopf = $('[data-kopfleiste]');
  if (kopf) {
    var letzteY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = Math.max(0, window.scrollY), unterschied = y - letzteY;
      var menueOffen = menue && !menue.hidden;
      if (y < kopf.offsetHeight || unterschied < -4 || menueOffen) kopf.classList.remove('kopf-weg');
      else if (unterschied > 4) kopf.classList.add('kopf-weg');
      if (Math.abs(unterschied) > 4) letzteY = y;
    }, { passive: true });
  }

  /* ---------- Holztür: beim ersten Besuch mit 18+-Abfrage (wie Altersabfrage.tsx),
     danach erst wieder, wenn man länger als TUER_PAUSE weg war – wer den Browser nur
     aus Versehen schließt und gleich wieder öffnet, kommt direkt rein ---------- */
  var TUER_PAUSE = 30 * 60 * 1000;
  var alter = $('[data-altersabfrage]');
  var eingetreten = Date.now() - speicher.lies('speakeasy_zuletzt_da', 0) < TUER_PAUSE;
  var anwesend = function () { speicher.schreibe('speakeasy_zuletzt_da', Date.now()); };
  var drinnen = false;
  var bleibDrin = function () {
    if (drinnen) return;
    drinnen = true;
    anwesend();
    // Solange die Seite offen ist, zählt die Pause nicht – sie beginnt erst beim Schließen/Wegwechseln
    setInterval(function () { if (!document.hidden) anwesend(); }, 60000);
    document.addEventListener('visibilitychange', anwesend);
    window.addEventListener('pagehide', anwesend);
  };
  var volljaehrig = speicher.lies('speakeasy_age_confirmed', false) === true;
  // Nach „Nein“ bleibt die Tür 24 Stunden zu (auch nach Neuladen) – danach wird wieder gefragt
  var SPERRE = 24 * 60 * 60 * 1000;
  var gesperrt = !volljaehrig && Date.now() - speicher.lies('speakeasy_age_denied', 0) < SPERRE;
  if (alter && (!volljaehrig || !eingetreten)) {
    zeige(alter, true);
    var frage = $('[data-alter-frage]', alter);
    var nein = $('[data-alter-abgelehnt]', alter);
    var willkommen = $('[data-tuer-willkommen]', alter);
    var tuerAuf = function () {
      bleibDrin();
      // Die Holztür schwingt auf, dahinter erscheint der Shop
      alter.classList.add('tuer-auf');
      setTimeout(function () { zeige(alter, false); }, ruhig ? 0 : 1150);
    };
    $('[data-alter-ja]', alter).addEventListener('click', function () {
      speicher.schreibe('speakeasy_age_confirmed', true);
      tuerAuf();
    });
    $('[data-tuer-eintreten]', alter).addEventListener('click', tuerAuf);
    $('[data-alter-nein]', alter).addEventListener('click', function () {
      speicher.schreibe('speakeasy_age_denied', Date.now());
      frage.hidden = true;
      nein.hidden = false;
    });
    if (gesperrt) { frage.hidden = true; nein.hidden = false; }
    if (volljaehrig) {
      frage.hidden = true;
      willkommen.hidden = false;
      alter.setAttribute('aria-labelledby', 'tuer-willkommen-titel');
      $('[data-tuer-eintreten]', alter).focus();
    } else {
      $('[data-alter-ja]', alter).focus();
    }
  }
  if (volljaehrig && (!alter || eingetreten)) bleibDrin();

  /* ---------- Bildansicht ---------- */
  var bildansicht = $('[data-bildansicht]');
  document.addEventListener('click', function (e) {
    var bild = e.target.closest('[data-bild-gross]');
    if (bild && bildansicht) { $('img', bildansicht).src = bild.getAttribute('data-bild-gross'); zeige(bildansicht, true); }
  });
  if (bildansicht) bildansicht.addEventListener('click', function () { zeige(bildansicht, false); });

  /* ---------- Warenkorb (Shopify Ajax Cart API) ---------- */
  var leiste = $('[data-warenkorb-leiste]');
  var aktuellerKorb = null;

  function anzeige(item) {
    var info = S.produkte[item.handle] || {};
    var auswahl = item.properties && item.properties['Mix & Match Auswahl'];
    var n = S.anzahlSorten;
    if (info.probierset) {
      return {
        name: auswahl ? 'Deine Mix & Match Box' : 'Probierset „Die ' + n + ' Zwerge“',
        groesse: auswahl ? n + 'x 100ml: ' + auswahl : n + 'x 100ml Set',
        bild: info.bild || item.image,
        quadrat: !info.bild
      };
    }
    return { name: info.name || item.product_title, groesse: info.groesse || (item.variant_title || ''), bild: info.bild || item.image, quadrat: !info.bild };
  }

  function versand(korb) {
    var summe = korb.total_price;
    var kosten = korb.item_count === 0 || summe >= S.gratisAb ? 0 : S.versandkosten;
    return { kosten: kosten, fehlt: Math.max(0, S.gratisAb - summe), fortschritt: Math.min(100, summe / S.gratisAb * 100) };
  }

  function rabattText(korb) {
    var codes = (korb.cart_level_discount_applications || []).map(function (d) { return d.title; }).filter(Boolean);
    return codes.length ? ' (' + esc(codes.join(', ')) + ')' : '';
  }

  function mengenKnoepfe(item, name, klasseBox, klasseKnopf, minus, zahlKlasse) {
    return '<div class="' + klasseBox + '">' +
      '<button type="button" data-menge="' + (item.quantity - 1) + '" data-key="' + esc(item.key) + '" aria-label="' + esc(name) + ' Menge verringern" class="' + klasseKnopf + '">' + minus + '</button>' +
      '<span class="' + zahlKlasse + '">' + item.quantity + '</span>' +
      '<button type="button" data-menge="' + (item.quantity + 1) + '" data-key="' + esc(item.key) + '" aria-label="' + esc(name) + ' Menge erhöhen" class="' + klasseKnopf + '">+</button>' +
      '</div>';
  }

  function renderLeiste(korb) {
    if (!leiste) return;
    var v = versand(korb);
    $('[data-warenkorb-versand]', leiste).innerHTML =
      '<div class="p-3.5 rounded-xl mb-4 border bg-[#181a24] border-neutral-800 light:bg-neutral-50 light:border-neutral-200">' +
        '<div class="text-xs mb-2">' + (v.fehlt > 0
          ? 'Noch <strong class="font-mono text-amber-400 light:text-amber-700">' + euro(v.fehlt) + '</strong> bis zum <strong>kostenlosen Versand</strong>!'
          : '<span class="text-green-500 font-bold">🎉 Gratis Versand freigeschaltet!</span>') + '</div>' +
        '<div class="w-full h-2 rounded-full overflow-hidden bg-neutral-800 light:bg-neutral-200"><div class="h-full transition-all duration-300 bg-amber-400 light:bg-neutral-900" style="width:' + v.fortschritt + '%"></div></div>' +
      '</div>';

    $('[data-warenkorb-artikel]', leiste).innerHTML = korb.item_count === 0
      ? '<div class="text-center py-12 text-neutral-500 text-sm">Dein Warenkorb ist noch leer.</div>'
      : '<div class="space-y-3 max-h-[45vh] overflow-y-auto pr-1">' + korb.items.map(function (item) {
          var a = anzeige(item);
          return '<div class="flex gap-3 items-center p-2.5 rounded-lg border bg-[#181a24] border-neutral-800 light:bg-neutral-50 light:border-neutral-200">' +
            vorschau(a, false) +
            '<div class="flex-1 min-w-0">' +
              '<h4 class="font-bold text-xs sm:text-sm truncate text-white light:text-[#241910]">' + esc(a.name) + '</h4>' +
              '<div class="text-[10px] text-neutral-400 light:text-neutral-700">' + esc(a.groesse) + '</div>' +
              '<div class="text-xs font-bold mt-0.5 font-mono text-amber-400 light:text-neutral-900">' + euro(item.final_line_price) + '</div>' +
            '</div>' +
            mengenKnoepfe(item, a.name, 'flex shrink-0 items-center gap-1 border rounded-md px-1 py-1 text-xs border-neutral-800 bg-[#12141c] light:border-neutral-300 light:bg-white', 'w-8 h-8 hover:opacity-75', '-', 'font-bold font-mono') +
          '</div>';
        }).join('') + '</div>';

    $('[data-warenkorb-summen]', leiste).innerHTML = korb.item_count === 0 ? '' :
      '<div class="border-t pt-4 mt-4 border-neutral-800">' +
        '<div class="flex justify-between text-xs mb-1 text-neutral-400"><span>Zwischensumme</span><span class="font-mono">' + euro(korb.original_total_price) + '</span></div>' +
        (korb.total_discount > 0 ? '<div class="flex justify-between text-xs mb-1 text-red-500 font-bold"><span>Rabatt' + rabattText(korb) + '</span><span class="font-mono">-' + euro(korb.total_discount) + '</span></div>' : '') +
        '<div class="flex justify-between text-xs mb-3 text-neutral-400"><span>Versandkosten</span><span class="font-mono">' + (v.kosten === 0 ? 'KOSTENLOS' : euro(v.kosten)) + '</span></div>' +
        '<div class="flex justify-between text-sm sm:text-base font-bold mb-4 font-mono text-amber-400 light:text-neutral-900"><span>Gesamtsumme</span><span>' + euro(korb.total_price + v.kosten) + '</span></div>' +
        '<button type="button" data-rezept-oeffnen class="block w-full mb-2 py-2 text-[11px] font-bold underline underline-offset-4 text-amber-400/90 hover:text-amber-300 light:text-neutral-700">Deinen Deckel ansehen</button>' +
        '<a href="' + wurzel + 'checkout" class="block text-center w-full font-black py-3 rounded-xl text-xs uppercase tracking-widest transition-all shadow-lg active:scale-95 border btn-primary">Zur Kasse Gehen</a>' +
      '</div>';
  }

  function renderSeite(korb) {
    var seite = $('[data-warenkorb-seite]');
    if (!seite) return;
    var anzahl = $('[data-warenkorb-seite-anzahl]');
    if (anzahl) anzahl.textContent = korb.item_count;
    var v = versand(korb);
    seite.innerHTML =
      '<div class="p-3.5 rounded-xl mb-5 border bg-[#181a24] border-neutral-800 light:bg-neutral-50 light:border-neutral-200">' +
        '<div class="text-xs mb-2">' + (v.fehlt > 0
          ? 'Noch <strong class="text-amber-400 light:text-amber-700">' + euro(v.fehlt) + '</strong> bis zum kostenlosen Versand.'
          : '<span class="text-green-500 font-bold">🎉 Gratis Versand freigeschaltet!</span>') + '</div>' +
        '<div class="w-full h-2 rounded-full overflow-hidden bg-neutral-800 light:bg-neutral-200"><div class="h-full transition-all duration-300 bg-amber-400 light:bg-neutral-900" style="width:' + v.fortschritt + '%"></div></div>' +
      '</div>' +
      (korb.item_count === 0
        ? '<div class="py-16 text-center text-sm text-neutral-500">Dein Warenkorb ist noch leer.</div>'
        : '<div class="space-y-3">' + korb.items.map(function (item) {
            var a = anzeige(item);
            return '<div class="flex gap-3 items-center p-3 rounded-xl border bg-[#181a24] border-neutral-800 light:bg-neutral-50 light:border-neutral-200">' +
              vorschau(a, true) +
              '<div class="flex-1 min-w-0">' +
                '<h2 class="font-bold text-sm truncate">' + esc(a.name) + '</h2>' +
                '<div class="text-[11px] opacity-60">' + esc(a.groesse) + '</div>' +
                '<div class="text-sm font-bold mt-1 font-mono text-amber-400 light:text-neutral-900">' + euro(item.final_line_price) + '</div>' +
              '</div>' +
              mengenKnoepfe(item, a.name, 'flex shrink-0 items-center gap-1 border rounded-lg px-1 py-1 text-xs border-neutral-800 bg-[#12141c] light:border-neutral-300 light:bg-white', 'w-8 h-8 hover:opacity-70', '−', 'font-bold font-mono min-w-5 text-center') +
            '</div>';
          }).join('') + '</div>' +
          '<div class="border-t mt-6 pt-5 border-neutral-800 max-w-md ml-auto">' +
            '<div class="flex justify-between text-xs mb-1 opacity-60"><span>Zwischensumme</span><span>' + euro(korb.original_total_price) + '</span></div>' +
            (korb.total_discount > 0 ? '<div class="flex justify-between text-xs mb-1 text-red-500 font-bold"><span>Rabatt' + rabattText(korb) + '</span><span>-' + euro(korb.total_discount) + '</span></div>' : '') +
            '<div class="flex justify-between text-xs mb-3 opacity-60"><span>Versand</span><span>' + (v.kosten === 0 ? 'KOSTENLOS' : euro(v.kosten)) + '</span></div>' +
            '<div class="flex justify-between text-lg font-black font-mono mb-4 text-amber-400 light:text-neutral-900"><span>Gesamt</span><span>' + euro(korb.total_price + v.kosten) + '</span></div>' +
        '<button type="button" data-rezept-oeffnen class="block w-full mb-2 py-2 text-[11px] font-bold underline underline-offset-4 text-amber-400/90 hover:text-amber-300 light:text-neutral-700">Deinen Deckel ansehen</button>' +
            '<a href="' + wurzel + 'checkout" class="block text-center w-full font-black py-3 rounded-xl text-xs uppercase tracking-widest border btn-primary">Zur Kasse</a>' +
          '</div>');
  }

  // Produktbild im Warenkorb: ganze Flasche im Hochformat, weich unterlegt wie auf den Produktkarten, mit goldenem Rahmen
  function vorschau(a, gross) {
    var b = esc(a.bild);
    return '<span class="warenkorb-bild' + (gross ? ' warenkorb-bild-gross' : '') + (a.quadrat ? ' warenkorb-bild-quadrat' : '') + '">' +
      '<img src="' + b + '" alt="" aria-hidden="true" class="wb-hinten">' +
      '<img src="' + b + '" alt="' + esc(a.name) + '" class="wb-vorne">' +
      '</span>';
  }

  function render(korb) {
    aktuellerKorb = korb;
    $$('[data-warenkorb-anzahl]').forEach(function (el) { el.textContent = korb.item_count; el.hidden = korb.item_count === 0; });
    renderLeiste(korb);
    renderSeite(korb);
  }

  function ladeKorb() {
    return fetch(wurzel + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(render);
  }

  function anfrage(url, daten) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(daten) })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw new Error(json.description || json.message || 'Das hat leider nicht geklappt.');
          return json;
        });
      });
  }

  /* ---------- Schmuggel-Lieferwagen: fährt nach „In den Warenkorb“ unten über den Bildschirm ---------- */
  // Ladung: vier Flaschen in den Sortenfarben wie auf der Apotheker-Waage (Popcorn, Spicy Mango, Sour Cuke, Salted Caramel).
  // Große Apothekerflaschen bei 500ml, kleine Zwerge bei 100ml, Probierset und Mix-Box.
  var LADUNG_FARBEN = ['#c98a26', '#efe04a', '#7cc242', '#c06a1c'];
  function laster(gross) {
    var ladung = LADUNG_FARBEN.map(function (farbe, i) {
      var k = 'flasche-' + 'abcd'.charAt(i);
      if (gross) {
        var x = 6 + i * 16;
        return '<g class="' + k + '"><rect x="' + (x + 4) + '" y="-1" width="4" height="6" fill="' + farbe + '" stroke="#ffb900" stroke-width="1"/>' +
          '<rect x="' + x + '" y="4" width="12" height="19" rx="3" fill="' + farbe + '" stroke="#ffb900" stroke-width="1.2"/>' +
          '<rect x="' + (x + 2) + '" y="10" width="8" height="6" rx="1" fill="#f4efe2" opacity=".85"/>' +
          '<rect x="' + (x + 3.5) + '" y="-5" width="5" height="4.5" rx="1" fill="#c8935a"/></g>';
      }
      var x2 = 10 + i * 15;
      return '<g class="' + k + '"><rect x="' + x2 + '" y="15" width="7" height="8" rx="1.5" fill="' + farbe + '" stroke="#ffb900" stroke-width="1"/>' +
        '<rect x="' + (x2 + 2) + '" y="12" width="3" height="3.5" rx=".8" fill="#c8935a"/></g>';
    }).join('');
    return '<svg viewBox="0 0 120 64" width="120" height="64" aria-hidden="true">' + ladung +
      '<rect x="4" y="22" width="66" height="26" rx="3" fill="#3b2412" stroke="#ffb900" stroke-width="2"/>' +
      '<text x="37" y="40" font-family="Georgia,serif" font-size="8" font-weight="bold" fill="#ffb900" text-anchor="middle">MOONSHINE</text>' +
      '<path d="M70 48V26h18l14 12v10z" fill="#12141c" stroke="#ffb900" stroke-width="2"/>' +
      '<path d="M76 30h10l8 7H76z" fill="#9fd3ff" opacity=".7"/>' +
      '<rect x="100" y="42" width="8" height="5" rx="1" fill="#ffb900"/>' +
      '<circle cx="24" cy="50" r="8" fill="#0b0c10" stroke="#ffb900" stroke-width="2"/><circle cx="24" cy="50" r="2.5" fill="#ffb900"/>' +
      '<circle cx="86" cy="50" r="8" fill="#0b0c10" stroke="#ffb900" stroke-width="2"/><circle cx="86" cy="50" r="2.5" fill="#ffb900"/>' +
      '</svg>';
  }

  function schmuggel(gross) {
    if (!document.body.animate) return Promise.resolve();
    var wagen = document.createElement('div');
    wagen.className = 'schmuggel-wagen';
    wagen.innerHTML = laster(gross) + '<span class="schmuggel-staub" aria-hidden="true"></span>';
    document.body.appendChild(wagen);
    var weg = window.innerWidth + 260;
    var fahrt = wagen.animate([
      { transform: 'translateX(0)' },
      { transform: 'translateX(' + weg * 0.45 + 'px) translateY(-3px)', offset: 0.45 },
      { transform: 'translateX(' + weg * 0.55 + 'px)', offset: 0.55 },
      { transform: 'translateX(' + weg + 'px)' }
    ], { duration: 2400, easing: 'cubic-bezier(.45,.05,.55,.95)' });
    return new Promise(function (fertig) {
      var ende = function () { wagen.remove(); fertig(); };
      fahrt.onfinish = ende;
      setTimeout(ende, 3100);   // falls die Animation hängt
    });
  }

  // Knopf-Rückmeldung beim In-den-Warenkorb-Legen: erst ein Ladekreis, dann kurz ein Häkchen
  function knopfZustand(knopf, zustand) {
    if (!knopf) return;
    if (zustand === 'laedt') { knopf.classList.add('knopf-laedt'); knopf.setAttribute('aria-busy', 'true'); return; }
    knopf.classList.remove('knopf-laedt'); knopf.removeAttribute('aria-busy');
    if (zustand === 'fertig') { knopf.classList.add('knopf-fertig'); setTimeout(function () { knopf.classList.remove('knopf-fertig'); }, 1700); }
  }

  function hinzufuegen(variante, eigenschaften, gross, knopf) {
    if (!variante) return Promise.resolve();
    var position = { id: Number(variante), quantity: 1 };
    if (eigenschaften) position.properties = eigenschaften;
    knopfZustand(knopf, 'laedt');
    return anfrage(wurzel + 'cart/add.js', { items: [position] })
      .then(ladeKorb)
      .then(function () { knopfZustand(knopf, 'fertig'); return schmuggel(gross); })
      .then(function () { zeige(leiste, true); })
      .catch(function (e) { knopfZustand(knopf, 'aus'); hinweis(e.message, 'fehler'); });
  }

  document.addEventListener('click', function (e) {
    var menge = e.target.closest('[data-menge]');
    if (menge) {
      anfrage(wurzel + 'cart/change.js', { id: menge.getAttribute('data-key'), quantity: Number(menge.getAttribute('data-menge')) })
        .then(render)
        .catch(function (err) { hinweis(err.message, 'fehler'); });
    }
    if (e.target.closest('[data-warenkorb-oeffnen]')) { zeige(leiste, true); if (menue) menue.hidden = true; }
    if (e.target.closest('[data-warenkorb-schliessen]')) zeige(leiste, false);
  });

  /* ---------- Produktkarten ---------- */
  var favoriten = speicher.lies('speakeasy_favoriten', []);
  var nurFavoriten = $('[data-nur-favoriten]');

  function aktualisiereFavoriten() {
    $$('[data-karte]').forEach(function (karte) {
      var knopf = $('[data-favorit-knopf]', karte);
      if (knopf) knopf.setAttribute('data-favorit', String(favoriten.indexOf(karte.getAttribute('data-handle')) > -1));
    });
    if (nurFavoriten) {
      nurFavoriten.hidden = favoriten.length === 0;
      if (favoriten.length === 0) nurFavoriten.setAttribute('aria-pressed', 'false');
      var nur = nurFavoriten.getAttribute('aria-pressed') === 'true';
      $$('#shop [data-karte]').forEach(function (karte) {
        karte.hidden = nur && favoriten.indexOf(karte.getAttribute('data-handle')) === -1;
      });
    }
  }

  if (nurFavoriten) {
    nurFavoriten.addEventListener('click', function () {
      nurFavoriten.setAttribute('aria-pressed', String(nurFavoriten.getAttribute('aria-pressed') !== 'true'));
      aktualisiereFavoriten();
    });
  }

  $$('[data-karte]').forEach(function (karte) {
    var groesse = '500';
    var preis = $('[data-preis]', karte);
    var kaufen = $('[data-in-warenkorb]', karte);

    function waehle(g) {
      groesse = g;
      $$('[data-groesse]', karte).forEach(function (b) {
        var aktiv = b.getAttribute('data-groesse') === g;
        b.classList.toggle('sel-active', aktiv);
        b.classList.toggle('sel-inactive', !aktiv);
      });
      // Foto passend zur Größe: große Flasche bei 500ml, Zwerg bei 100ml.
      // Überblendung: das neue Foto schärft sich aus leichter Unschärfe heran, das alte tritt weich zurück – ohne Lücke dazwischen.
      var neuesBild = karte.getAttribute('data-bild' + g);
      var bildFeld = $('[data-bild-gross]', karte);
      if (neuesBild && bildFeld && bildFeld.getAttribute('data-bild-gross') !== neuesBild) {
        bildFeld.setAttribute('data-bild-gross', neuesBild);
        if (karte._bildWechselFertig) karte._bildWechselFertig();   // laufenden Wechsel sofort abschließen (schnelles Hin- und Herschalten)
        var bilder = $$('[data-karten-bild]', karte);
        var stillHalten = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var vorab = new Image();
        var starten = function () {
          if (bildFeld.getAttribute('data-bild-gross') !== neuesBild) return;   // inzwischen wieder umgeschaltet
          if (stillHalten || !bildFeld.animate) { bilder.forEach(function (img) { img.src = neuesBild; }); return; }
          var dauer = 560, kurve = 'cubic-bezier(.22,.61,.36,1)';
          // neue Bilder als Kopien über die alten legen; am Ende bleiben die Kopien, die alten fliegen raus (kein erneutes Laden, kein Flackern)
          var kopien = bilder.map(function (img, i) {
            var k = img.cloneNode(false);
            k.removeAttribute('loading'); k.src = neuesBild;
            img.removeAttribute('data-karten-bild');
            img.parentNode.insertBefore(k, img.nextSibling);
            var vorne = i === bilder.length - 1;
            k.animate(vorne
              ? [{ opacity: 0, transform: 'scale(1.06)', filter: 'blur(10px)' }, { opacity: 1, transform: 'scale(1)', filter: 'blur(0)' }]
              : [{ opacity: 0 }, { opacity: 1 }], { duration: dauer, easing: kurve, fill: 'both' });
            if (vorne) img.animate([{ opacity: 1, transform: 'scale(1)', filter: 'blur(0)' }, { opacity: 0, transform: 'scale(.97)', filter: 'blur(6px)' }], { duration: dauer * .8, easing: kurve, fill: 'both' });
            return k;
          });
          var uhr = null;
          var fertig = karte._bildWechselFertig = function () {
            clearTimeout(uhr);
            karte._bildWechselFertig = null;
            bilder.forEach(function (img) { img.remove(); });
            kopien.forEach(function (k) { k.getAnimations().forEach(function (a) { a.cancel(); }); });
          };
          uhr = setTimeout(fertig, dauer + 40);
        };
        vorab.onload = function () { (vorab.decode ? vorab.decode() : Promise.resolve()).then(starten, starten); };
        vorab.onerror = starten;
        vorab.src = neuesBild;
      }
      if (preis) preis.textContent = euro(Number(karte.getAttribute('data-p' + g)));
      var grundpreis = $('[data-grundpreis]', karte);
      var ml = Number(karte.getAttribute('data-ml' + g));
      if (grundpreis && ml) grundpreis.textContent = euro(Math.round(Number(karte.getAttribute('data-p' + g)) * 1000 / ml));
      if (kaufen) {
        var da = karte.getAttribute('data-a' + g) === 'true';
        kaufen.disabled = !da;
        kaufen.textContent = da ? 'In den Warenkorb' : 'Ausverkauft ❌';
      }
    }

    $$('[data-groesse]', karte).forEach(function (b) { b.addEventListener('click', function () { waehle(b.getAttribute('data-groesse')); }); });
    if (kaufen) kaufen.addEventListener('click', function () { hinzufuegen(karte.getAttribute('data-v' + groesse), null, groesse === '500', kaufen); });

    var herz = $('[data-favorit-knopf]', karte);
    if (herz) {
      herz.addEventListener('click', function (e) {
        e.stopPropagation();
        var handle = karte.getAttribute('data-handle');
        var i = favoriten.indexOf(handle);
        if (i > -1) favoriten.splice(i, 1); else favoriten.push(handle);
        speicher.schreibe('speakeasy_favoriten', favoriten);
        aktualisiereFavoriten();
      });
    }
    waehle('500');
  });
  aktualisiereFavoriten();

  /* ---------- Probierset & Mix-&-Match-Box ---------- */
  $$('[data-probierset]').forEach(function (b) {
    b.addEventListener('click', function () { hinzufuegen(b.getAttribute('data-probierset'), null, false, b); });
  });

  var mixbox = $('[data-mixbox]');
  if (mixbox) {
    var ziel = Number(mixbox.getAttribute('data-anzahl'));
    var auswahl = [];
    var summe = $('[data-mix-summe]', mixbox);
    var fertig = $('[data-mix-hinzufuegen]', mixbox);

    /* Apotheker-Waage: links die Zwerge, rechts das Gewicht – gerade, wenn die Box voll ist */
    var waageSvg = $('[data-waage]', mixbox);
    // Flüssigkeitsfarbe je Sorte (am Namen erkannt) – wie die Flaschen auf dem Lieferwagen
    var sortenFarbe = function (name) {
      var n = String(name).toLowerCase();
      if (n.indexOf('popcorn') > -1) return '#c98a26';
      if (n.indexOf('caramel') > -1 || n.indexOf('karamell') > -1) return '#c06a1c';
      if (n.indexOf('mango') > -1) return '#efe04a';
      if (n.indexOf('cuke') > -1 || n.indexOf('gurke') > -1) return '#7cc242';
      if (n.indexOf('pista') > -1) return '#a3b86c';
      return '#e8f5c8';
    };
    var waage = function (gewaehlt, max) {
      var n = gewaehlt.length;
      if (!waageSvg) return;
      var winkel = (1 - n / max) * 14;              // leer: rechte Schale (Gewicht) unten
      var rad = winkel * Math.PI / 180, arm = 82;
      // per CSS-Transform, damit die Waage sanft nachschwingt
      $('[data-waage-balken]', waageSvg).style.transform = 'rotate(' + winkel + 'deg)';
      $('[data-waage-links]', waageSvg).style.transform = 'translate(' + (arm - arm * Math.cos(rad)) + 'px,' + (-arm * Math.sin(rad)) + 'px)';
      $('[data-waage-rechts]', waageSvg).style.transform = 'translate(' + (-(arm - arm * Math.cos(rad))) + 'px,' + (arm * Math.sin(rad)) + 'px)';
      var ladung = '';
      for (var i = 0; i < n; i++) {
        var x = 20 + (i % 4) * 9, y = 52 - Math.floor(i / 4) * 13;
        ladung += '<rect x="' + x + '" y="' + y + '" width="7" height="12" rx="1.5" fill="' + sortenFarbe(gewaehlt[i]) + '" stroke="#ffb900" stroke-width=".8"/>' +
          '<rect x="' + (x + 2) + '" y="' + (y - 3) + '" width="3" height="3.5" fill="#c8935a"/>';
      }
      $('[data-waage-ladung]', waageSvg).innerHTML = ladung;
      var text = $('[data-waage-text]', mixbox);
      if (text) {
        text.textContent = n >= max ? '⚖️ Perfekt ausgewogen! Deine Box ist komplett.' : 'Noch ' + (max - n) + ' Zwerg' + (max - n === 1 ? '' : 'e') + ' bis zum Gleichgewicht.';
        text.className = 'mt-1 text-[11px] font-bold ' + (n >= max ? 'text-green-500' : 'text-neutral-400');
      }
    };

    var aktualisiereMix = function () {
      $$('[data-mix-sorte]', mixbox).forEach(function (zeile) {
        var name = zeile.getAttribute('data-mix-sorte');
        var zahl = auswahl.filter(function (n) { return n === name; }).length;
        $('[data-mix-zahl]', zeile).textContent = zahl;
        $('[data-mix-minus]', zeile).disabled = zahl === 0;
        $('[data-mix-plus]', zeile).disabled = auswahl.length >= ziel || zeile.hasAttribute('data-mix-aus');   // ausverkaufte Zwerge sperren
      });
      summe.textContent = auswahl.length;
      waage(auswahl, ziel);
      fertig.disabled = auswahl.length !== ziel;
    };

    $$('[data-mix-sorte]', mixbox).forEach(function (zeile) {
      var name = zeile.getAttribute('data-mix-sorte');
      $('[data-mix-plus]', zeile).addEventListener('click', function () { if (auswahl.length < ziel && !zeile.hasAttribute('data-mix-aus')) { auswahl.push(name); aktualisiereMix(); } });
      $('[data-mix-minus]', zeile).addEventListener('click', function () {
        var i = auswahl.indexOf(name);
        if (i > -1) { auswahl.splice(i, 1); aktualisiereMix(); }
      });
    });

    fertig.addEventListener('click', function () {
      if (auswahl.length !== ziel) { hinweis('Wähle genau ' + ziel + '× Zwerge für deine Box aus.', 'fehler'); return; }
      var gewaehlt = auswahl.join(', ');
      zeige(mixbox, false);
      auswahl = [];
      aktualisiereMix();
      hinzufuegen(mixbox.getAttribute('data-variante'), { 'Mix & Match Auswahl': gewaehlt });
    });

    $$('[data-mixbox-oeffnen]').forEach(function (b) { b.addEventListener('click', function () { zeige(mixbox, true); }); });
    $$('[data-mixbox-schliessen]', mixbox).forEach(function (b) { b.addEventListener('click', function () { zeige(mixbox, false); }); });
    aktualisiereMix();
  }

  /* ---------- Schnitzeljagd: versteckte Gegenstände, Fortschritt nur beim Finden ---------- */
  var jagd = $('[data-jagd-dialog]');
  if (jagd) {
    var alleFunde = $$('[data-jagd-eintrag]', jagd).map(function (e) { return e.getAttribute('data-jagd-eintrag'); });
    var funde = speicher.lies('speakeasy_funde', []).filter(function (id) { return alleFunde.indexOf(id) > -1; });

    var aktualisiereJagd = function () {
      var n = funde.length, gesamt = alleFunde.length, komplett = n >= gesamt;
      $$('[data-jagd-slot]').forEach(function (slot) {
        var da = funde.indexOf(slot.getAttribute('data-jagd-slot')) > -1;
        slot.textContent = da ? slot.getAttribute('data-emoji') : '?';
        slot.classList.toggle('jagd-slot-da', da);
      });
      $$('[data-jagd-eintrag]', jagd).forEach(function (e) {
        var da = funde.indexOf(e.getAttribute('data-jagd-eintrag')) > -1;
        $('[data-jagd-name]', e).textContent = da ? e.getAttribute('data-name') : '???';
        $('[data-jagd-unter]', e).hidden = da;
        e.classList.toggle('border-amber-400/50', da);
        var status = $('[data-jagd-status]', e);
        if (da) { status.textContent = '✓ Gefunden'; status.className = 'shrink-0 text-[10px] font-black uppercase tracking-wider text-green-500'; }
      });
      $('[data-jagd-dialog-zahl]', jagd).textContent = n;
      $('[data-jagd-balken]', jagd).style.width = (n / gesamt * 100) + '%';
      $('[data-jagd-komplett]', jagd).hidden = !komplett;
      $$('[data-fund]').forEach(function (el) { if (funde.indexOf(el.getAttribute('data-fund')) > -1) el.setAttribute('data-gefunden', 'true'); });
    };

    var oeffneJagd = function (fund) {
      var info = $('[data-jagd-fund]', jagd);
      info.hidden = !fund;
      $('[data-jagd-kopf]', jagd).hidden = !!fund;
      if (fund) {
        $('[data-jagd-fund-emoji]', jagd).textContent = fund.getAttribute('data-fund-emoji');
        $('[data-jagd-fund-titel]', jagd).textContent = fund.getAttribute('data-fund-titel');
        $('[data-jagd-fund-text]', jagd).textContent = fund.getAttribute('data-fund-text');
      }
      zeige(jagd, true);
    };

    $$('[data-fund]').forEach(function (el) {
      el.addEventListener('click', function () {
        var id = el.getAttribute('data-fund');
        if (funde.indexOf(id) === -1) {
          funde.push(id);
          speicher.schreibe('speakeasy_funde', funde);
        }
        aktualisiereJagd();
        if (funde.length >= alleFunde.length && sieg) zeigeSieg();   // beim letzten Fund – und später erneut über jedes Fundstück
        else oeffneJagd(el);
      });
    });
    /* Glückwunsch mit Konfetti und Rabattcode */
    var sieg = $('[data-jagd-sieg]');
    var zeigeSieg = function () {
      zeige(jagd, false);
      zeige(sieg, true);
      var box = $('[data-konfetti]', sieg);
      box.innerHTML = '';
      if (ruhig) return;
      var farben = ['#ffb900', '#ffffff', '#4ade80', '#f59e0b', '#fde68a'];
      for (var i = 0; i < 90; i++) {
        var k = document.createElement('span');
        k.className = 'konfetti';
        k.style.left = Math.random() * 100 + '%';
        k.style.background = farben[i % farben.length];
        k.style.animationDelay = (Math.random() * 0.8).toFixed(2) + 's';
        k.style.animationDuration = (2.2 + Math.random() * 1.6).toFixed(2) + 's';
        k.style.setProperty('--drift', (Math.random() * 160 - 80).toFixed(0) + 'px');
        box.appendChild(k);
      }
      setTimeout(function () { box.innerHTML = ''; }, 4500);
    };
    if (sieg) {
      $$('[data-jagd-sieg-schliessen]', sieg).forEach(function (b) { b.addEventListener('click', function () { zeige(sieg, false); }); });
      var kopieren = $('[data-jagd-kopieren]', sieg);
      if (kopieren) {
        kopieren.addEventListener('click', function () {
          var code = $('[data-jagd-code]', sieg).textContent.trim();
          var fertig = function () { kopieren.textContent = '✓ Kopiert!'; setTimeout(function () { kopieren.textContent = '📋 Code kopieren'; }, 2000); };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(fertig, function () { hinweis('Code: ' + code); });
          } else {
            var feld = document.createElement('textarea');
            feld.value = code; document.body.appendChild(feld); feld.select();
            try { document.execCommand('copy'); fertig(); } catch (e) { hinweis('Code: ' + code); }
            feld.remove();
          }
        });
      }
    }
    $$('[data-jagd-schliessen]', jagd).forEach(function (b) { b.addEventListener('click', function () { zeige(jagd, false); }); });
    aktualisiereJagd();
  }

  /* ---------- Gemeinsame Helfer: Zettel zeichnen, Bild speichern / teilen / kopieren ---------- */
  var SERIF = 'Georgia, "Times New Roman", serif';
  var TINTE = '#2b2118';
  var GOLD = '#a8781c';
  var stift = null;   // aktuelle Zeichenfläche (Deckel oder Geheimrezept)
  var schreib = function (t, x, y, groesse, stil, farbe, ausr) {
    stift.font = (stil || 'normal') + ' ' + groesse + 'px ' + SERIF;
    stift.fillStyle = farbe || TINTE;
    stift.textAlign = ausr || 'left';
    stift.fillText(t, x, y);
  };
  var umbrechen = function (text, breite, groesse, stil) {
    stift.font = stil + ' ' + groesse + 'px ' + SERIF;
    var zeilen = [], zeile = '';
    text.split(' ').forEach(function (w) {
      var test = zeile ? zeile + ' ' + w : w;
      if (stift.measureText(test).width > breite && zeile) { zeilen.push(zeile); zeile = w; } else zeile = test;
    });
    if (zeile) zeilen.push(zeile);
    return zeilen;
  };
  // Weihnachtsschmuck für die Zettel: Stechpalmen, Lichterkette, Schneeflocken, Zuckerstangen-Rand
  var stechpalme = function (x, y, drehung, mass) {
    stift.save(); stift.translate(x, y); stift.rotate(drehung); stift.scale(mass, mass);
    [-1, 1].forEach(function (r) {
      stift.beginPath(); stift.moveTo(0, 0); stift.bezierCurveTo(r * 14, -14, r * 34, -8, r * 36, 6); stift.bezierCurveTo(r * 24, 14, r * 8, 12, 0, 0); stift.closePath();
      stift.fillStyle = '#2e8b57'; stift.fill(); stift.strokeStyle = '#1d5f3a'; stift.lineWidth = 1.5; stift.stroke();
    });
    [[-5, 6], [6, 8], [0, -1]].forEach(function (b) {
      stift.beginPath(); stift.arc(b[0], b[1], 5, 0, Math.PI * 2); stift.fillStyle = '#d6232a'; stift.fill(); stift.strokeStyle = '#8a1a1f'; stift.lineWidth = 1; stift.stroke();
      stift.beginPath(); stift.arc(b[0] - 1.5, b[1] - 1.5, 1.4, 0, Math.PI * 2); stift.fillStyle = 'rgba(255,255,255,.65)'; stift.fill();
    });
    stift.restore();
  };
  var flocke = function (x, y, r) {
    stift.save(); stift.translate(x, y); stift.strokeStyle = 'rgba(120,150,190,.35)'; stift.lineWidth = 2; stift.lineCap = 'round';
    for (var i = 0; i < 6; i++) {
      stift.rotate(Math.PI / 3);
      stift.beginPath(); stift.moveTo(0, 0); stift.lineTo(0, -r); stift.moveTo(0, -r * .6); stift.lineTo(r * .25, -r * .85); stift.moveTo(0, -r * .6); stift.lineTo(-r * .25, -r * .85); stift.stroke();
    }
    stift.restore();
  };
  var lichterkette = function (x0, y0, schwuenge, breite, draht) {
    var farben = ['#c9232b', '#e8b730', '#2e8b57', '#3b6fd1'], nr = 0;
    stift.strokeStyle = draht || '#5a4428'; stift.lineWidth = 1.6;
    for (var sw = 0; sw < schwuenge; sw++) {
      var ax = x0 + sw * breite;
      stift.beginPath(); stift.moveTo(ax, y0); stift.quadraticCurveTo(ax + breite / 2, y0 + 18, ax + breite, y0); stift.stroke();
      [0.3, 0.7].forEach(function (t) {
        var bx = ax + breite * t, by = (1 - t) * (1 - t) * y0 + 2 * (1 - t) * t * (y0 + 18) + t * t * y0;
        stift.save(); stift.shadowColor = farben[nr % 4]; stift.shadowBlur = 7;
        stift.fillStyle = farben[nr % 4]; stift.beginPath(); stift.ellipse(bx, by + 7, 3.8, 5.6, 0, 0, Math.PI * 2); stift.fill(); stift.restore();
        stift.fillStyle = '#3a2a18'; stift.fillRect(bx - 2, by - 0.5, 4, 3);
        nr++;
      });
    }
  };
  // Papier, Whiskey-Ring, Art-Déco-Rahmen und Kopfzeile: für Deckel und Geheimrezept gleich
  var zettelGrund = function (kopf, untertitel, weihnachtlich) {
    // Altes, vergilbtes Papier
    stift.fillStyle = '#efe2c2';
    stift.fillRect(0, 0, 600, 800);
    var rand = stift.createRadialGradient(300, 400, 200, 300, 400, 560);
    rand.addColorStop(0, 'rgba(0,0,0,0)');
    rand.addColorStop(1, 'rgba(90,60,25,.55)');
    stift.fillStyle = rand;
    stift.fillRect(0, 0, 600, 800);
    // Whiskey-Ring (Glas wurde auf dem Zettel abgestellt)
    stift.strokeStyle = 'rgba(150,95,30,.22)';
    stift.lineWidth = 9;
    stift.beginPath(); stift.arc(470, 205, 62, 0.3, Math.PI * 1.85); stift.stroke();
    stift.lineWidth = 3;
    stift.beginPath(); stift.arc(470, 205, 52, 0, Math.PI * 2); stift.stroke();
    if (weihnachtlich) {
      // Zuckerstangen-Rand
      var muster = document.createElement('canvas'); muster.width = muster.height = 28;
      var mk = muster.getContext('2d'); mk.fillStyle = '#fbfaf6'; mk.fillRect(0, 0, 28, 28);
      mk.strokeStyle = '#c9232b'; mk.lineWidth = 14;
      [-28, 0, 28].forEach(function (o) { mk.beginPath(); mk.moveTo(o, 28); mk.lineTo(o + 28, 0); mk.stroke(); });
      stift.strokeStyle = stift.createPattern(muster, 'repeat'); stift.lineWidth = 12; stift.strokeRect(6, 6, 588, 788);
      flocke(110, 300, 22); flocke(520, 340, 18); flocke(92, 560, 16); flocke(505, 585, 20);
    }
    // Art-Déco-Rahmen
    stift.strokeStyle = GOLD;
    stift.lineWidth = 3; stift.strokeRect(22, 22, 556, 756);
    stift.lineWidth = 1; stift.strokeRect(32, 32, 536, 736);
    [[32, 32, 1, 1], [568, 32, -1, 1], [32, 768, 1, -1], [568, 768, -1, -1]].forEach(function (e) {
      stift.beginPath();
      stift.moveTo(e[0], e[1] + 40 * e[3]); stift.lineTo(e[0] + 18 * e[2], e[1] + 18 * e[3]); stift.lineTo(e[0] + 40 * e[2], e[1]);
      stift.stroke();
    });
    if (weihnachtlich) {
      lichterkette(60, 40, 6, 80);
      stechpalme(54, 56, -0.7, 1.15); stechpalme(546, 56, 0.7, 1.15); stechpalme(44, 758, 2.6, .9); stechpalme(556, 758, -2.6, .9);
    }
    // Kopf
    schreib(kopf, 300, 84, 13, 'bold', weihnachtlich ? '#a81f27' : GOLD, 'center');
    schreib('SPEAKEASY', 300, 126, 46, 'bold', TINTE, 'center');
    schreib(untertitel, 300, 150, 16, 'italic', '#5a4428', 'center');
    stift.fillStyle = GOLD;
    stift.fillRect(80, 168, 440, 2);
  };
  // Fuß: Unterschrift des Barkeepers und Stempel
  var zettelFuss = function (weihnachtlich) {
    stift.fillStyle = GOLD;
    stift.fillRect(80, 628, 440, 1.5);
    schreib('Psst … nichts weitersagen. Abgabe nur an Erwachsene ab 18 Jahren.', 300, 656, 13, 'italic', '#5a4428', 'center');
    schreib('gez. der Barkeeper', 430, 730, 24, 'italic', '#1f3a6b', 'center');
    stift.strokeStyle = TINTE; stift.lineWidth = 1;
    stift.beginPath(); stift.moveTo(330, 742); stift.lineTo(530, 742); stift.stroke();
    // Stempel „Streng geheim“
    stift.save();
    stift.translate(weihnachtlich ? 186 : 165, 712);
    stift.rotate(-0.18);
    stift.strokeStyle = 'rgba(160,30,30,.8)';
    stift.fillStyle = 'rgba(160,30,30,.8)';
    stift.lineWidth = 3; stift.strokeRect(-112, -32, 224, 64);
    stift.lineWidth = 1.2; stift.strokeRect(-105, -25, 210, 50);
    stift.font = 'bold 20px ' + SERIF; stift.textAlign = 'center';
    stift.fillText(weihnachtlich ? 'FROHES FEST' : 'STRENG GEHEIM', 0, 2);
    stift.font = 'bold 10px ' + SERIF;
    stift.fillText('★ SPEAKEASY MOONSHINE ★', 0, 18);
    stift.restore();
  };
  // Bild speichern, teilen (Handy, wenn das Gerät es kann) oder in die Zwischenablage kopieren (PC, wenn das Gerät es kann)
  var bildAktionen = function (o) {
    var wert = function (v) { return typeof v === 'function' ? v() : v; };
    var alsDatei = function (fertig) {
      o.blatt.toBlob(function (b) { fertig(new File([b], wert(o.name), { type: 'image/png' })); }, 'image/png');
    };
    if (o.speichern) o.speichern.addEventListener('click', function () {
      alsDatei(function (d) {
        var a = document.createElement('a');
        a.href = URL.createObjectURL(d);
        a.download = d.name;
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
      });
    });
    var kannTeilen = false;
    try { kannTeilen = !!(navigator.share && navigator.canShare && navigator.canShare({ files: [new File([''], 'x.png', { type: 'image/png' })] })); } catch (err) {}
    if (o.teilen && kannTeilen) {
      o.teilen.hidden = false;
      o.teilen.addEventListener('click', function () {
        alsDatei(function (d) { navigator.share({ files: [d], title: wert(o.titel), text: wert(o.text) }).catch(function () {}); });
      });
    }
    if (o.kopieren && !kannTeilen && window.ClipboardItem && navigator.clipboard && navigator.clipboard.write) {
      o.kopieren.hidden = false;
      o.kopieren.addEventListener('click', function () {
        var blob = new Promise(function (ok) { o.blatt.toBlob(ok, 'image/png'); });
        navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })])
          .then(function () { hinweis('Bild kopiert. Einfach einfügen und verschicken.'); })
          .catch(function () { hinweis('Kopieren hat nicht geklappt. Speichere das Bild stattdessen.', 'fehler'); });
      });
    }
  };

  /* ---------- Hinterzimmer: geheime Klopfzeichen auf dem Logo, jedes öffnet ein anderes Geheimrezept ---------- */
  // Klopfzeichen = Schläge pro Gruppe (Gruppen durch eine kurze Pause getrennt). Die Schläge entsprechen den ersten
  // beiden Teilen des Rezepts. Es gelten genau die Kombinationen des jeweiligen Satzes (normal oder Weihnachten) und
  // keine andere. Keine darf der Anfang einer anderen sein, und die erste Gruppe hat mindestens 2 Schläge
  // (ein einzelner Klick führt zur Startseite).
  var REZEPTE_NORMAL = [
    { code: [2, 1], name: 'Popcorn Sour', unter: 'mit Popcorn-Likör',
      zutaten: ['2 Teile Popcorn-Likör', '1 Teil frischer Zitronensaft', '2 Teile Bourbon', 'Eis und ein paar Popcorn-Kerne'],
      schritte: '1 Teil = 2 cl. Alles mit viel Eis kräftig shaken, in ein gekühltes Glas abseihen und mit ein paar Popcorn-Kernen krönen.' },
    { code: [3, 1], name: 'Spicy Mango Mule', unter: 'mit Spicy-Mango-Likör',
      zutaten: ['3 Teile Spicy-Mango-Likör', '1 Teil Limettensaft', '5 Teile Ginger Beer', 'Eis, Limettenspalte und Minze'],
      schritte: '1 Teil = 2 cl. Likör und Limettensaft in einen Becher über viel Eis geben, mit Ginger Beer auffüllen und kurz umrühren.' },
    { code: [2, 2], name: 'Salted Caramel Espresso', unter: 'mit Salted-Caramel-Likör',
      zutaten: ['2 Teile Salted-Caramel-Likör', '2 Teile kalter Espresso', '1 Teil Wodka', 'Eis und drei Kaffeebohnen'],
      schritte: '1 Teil = 2 cl. Alles mit Eis hart shaken, in eine Coupette abseihen und mit drei Kaffeebohnen garnieren. Auf Wunsch mit einer Prise Salz.' }
  ];
  var REZEPTE_WEIHNACHT = [
    { code: [2, 3], name: 'Heißer Salted-Caramel-Apfel', unter: 'mit Salted-Caramel-Likör',
      zutaten: ['2 Teile Salted-Caramel-Likör', '3 Teile heißer Apfelsaft', 'Eine Zimtstange', 'Sahnehaube und eine Prise Zimt'],
      schritte: '1 Teil = 3 cl. Likör in eine Tasse geben, mit heißem Apfelsaft auffüllen, die Zimtstange hineinstellen und eine Sahnehaube obenauf setzen.' },
    { code: [3, 2], name: 'Popcorn-Winterlatte', unter: 'mit Popcorn-Likör',
      zutaten: ['3 Teile heiße Milch', '2 Teile Popcorn-Likör', 'Eine Prise Zimt', 'Milchschaum und Popcorn-Kerne'],
      schritte: '1 Teil = 3 cl. Likör in ein Glas geben, mit heißer Milch auffüllen, Milchschaum aufsetzen und mit Zimt und ein paar Popcorn-Kernen bestreuen.' },
    { code: [4, 1], name: 'Spicy Mango Glühpunsch', unter: 'mit Spicy-Mango-Likör',
      zutaten: ['4 Teile heißer Glühwein', '1 Teil Spicy-Mango-Likör', 'Eine Orangenscheibe', 'Ein Stern Anis'],
      schritte: '1 Teil = 4 cl. Glühwein erhitzen, aber nicht kochen. Likör in die Tasse geben, mit dem Glühwein auffüllen und mit Orange und Sternanis servieren.' }
  ];
  var REZEPTE = document.documentElement.hasAttribute('data-weihnacht') ? REZEPTE_WEIHNACHT : REZEPTE_NORMAL;
  var logo = $('[data-logo]');
  var hinterzimmer = $('[data-hinterzimmer]');
  if (logo && hinterzimmer) {
    var kartenBlatt = $('[data-hinterzimmer-bild]', hinterzimmer);
    var offenesRezept = REZEPTE[0];
    var zeichneGeheimrezept = function (r) {
      var nr = REZEPTE.indexOf(r) + 1;
      var weihnachtlich = document.documentElement.hasAttribute('data-weihnacht');
      stift = kartenBlatt.getContext('2d');
      zettelGrund(weihnachtlich ? '★ FROHE WEIHNACHTEN ★' : '★ GEHEIMREZEPT ★', weihnachtlich ? '— Weihnachten in der Flüsterkneipe —' : '— Flüsterkneipe · Hinterzimmer —', weihnachtlich);
      var heute = new Date();
      var datum = ('0' + heute.getDate()).slice(-2) + '.' + ('0' + (heute.getMonth() + 1)).slice(-2) + '.1926';
      schreib('Rezept Nr. ' + nr + ' von ' + REZEPTE.length, 60, 205, 18, 'italic', TINTE);
      schreib(datum, 540, 205, 16, 'italic', TINTE, 'right');
      var groesse = 38;
      stift.font = 'italic bold ' + groesse + 'px ' + SERIF;
      while (stift.measureText(r.name).width > 470 && groesse > 22) { groesse -= 2; stift.font = 'italic bold ' + groesse + 'px ' + SERIF; }
      schreib(r.name, 60, 262, groesse, 'italic bold', '#7a1f12');
      schreib(r.unter, 60, 290, 17, 'italic', '#5a4428');
      // Klopfzeichen als Punkte, wie auf dem Mitgliedsausweis
      schreib('KLOPFZEICHEN AM LOGO', 60, 334, 12, 'bold', '#6b5236');
      var px = 262;
      r.code.forEach(function (n) {
        for (var k = 0; k < n; k++) { stift.beginPath(); stift.arc(px, 330, 6, 0, Math.PI * 2); stift.fillStyle = TINTE; stift.fill(); px += 20; }
        px += 22;
      });
      stift.fillStyle = GOLD; stift.fillRect(60, 348, 480, 1);
      schreib('Zutaten', 60, 378, 22, 'italic bold', GOLD);
      r.zutaten.forEach(function (z, i) {
        stift.beginPath(); stift.arc(72, 408 + i * 26 - 6, 3, 0, Math.PI * 2); stift.fillStyle = GOLD; stift.fill();
        schreib(z, 88, 408 + i * 26, 20, 'italic', TINTE);
      });
      schreib('Zubereitung', 60, 530, 22, 'italic bold', GOLD);
      umbrechen(r.schritte, 470, 17, 'italic').slice(0, 3).forEach(function (z, i) { schreib(z, 60, 558 + i * 24, 17, 'italic', TINTE); });
      zettelFuss(weihnachtlich);
    };
    var oeffneRezept = function (r) {
      offenesRezept = r;
      zeichneGeheimrezept(r);
      $('[data-hinterzimmer-text]', hinterzimmer).textContent = 'Geheimrezept ' + r.name + '. Zutaten: ' + r.zutaten.join(', ') + '. ' + r.schritte;
      var gefunden = speicher.lies('speakeasy_geheimrezepte', []);
      if (gefunden.indexOf(r.name) < 0) { gefunden.push(r.name); speicher.schreibe('speakeasy_geheimrezepte', gefunden); }
      var anzahl = REZEPTE.filter(function (x) { return gefunden.indexOf(x.name) > -1; }).length;
      var fund = $('[data-hinterzimmer-fund]', hinterzimmer);
      if (fund) fund.textContent = 'Du hast ' + anzahl + ' von ' + REZEPTE.length + ' Geheimrezepten gefunden.' +
        (anzahl < REZEPTE.length ? ' Tipp: Jedes Rezept hat sein eigenes Klopfzeichen. Die Schläge sind die ersten beiden Teile im Rezept.' : ' Alle gefunden. Du bist ein echter Eingeweihter.');
      zeige(hinterzimmer, true);
    };
    var klopfer = [], auswertTimer = null, resetTimer = null;
    var RUHE = 800, PAUSE_MAX = 4000;   // großzügig, damit es auch am Handy klappt
    // Gruppen erkennen: kurze Abstände gehören zusammen, deutlich längere sind die Pause.
    // Das richtet sich nach dem Tempo des Klopfenden, egal ob schnell oder gemütlich.
    var gruppen = function (t) {
      var luecken = [];
      for (var i = 1; i < t.length; i++) luecken.push(t[i] - t[i - 1]);
      var kurz = Math.min.apply(null, luecken.concat([RUHE]));
      var schwelle = Math.max(kurz * 1.7, kurz + 180, 340);
      var g = [1];
      luecken.forEach(function (l) { if (l > schwelle) g.push(1); else g[g.length - 1]++; });
      return g;
    };
    var beginnt = function (g, code) { return g.length <= code.length && g.every(function (z, i) { return z === code[i]; }); };
    var auswerten = function () {
      // Ein einzelner Klick bleibt, was er war: zur Startseite (dort nach oben)
      if (klopfer.length === 1) {
        klopfer = [];
        if (logo.pathname === window.location.pathname) window.scrollTo({ top: 0, behavior: ruhig ? 'auto' : 'smooth' });
        else window.location.href = logo.href;
        return;
      }
      var g = gruppen(klopfer);
      var treffer = REZEPTE.filter(function (r) { return r.code.length === g.length && beginnt(g, r.code); })[0];
      if (treffer) { klopfer = []; clearTimeout(resetTimer); oeffneRezept(treffer); return; }
      // Passt es noch als Anfang eines Klopfzeichens, darf es weitergehen, sonst von vorn
      if (!REZEPTE.some(function (r) { return r.code.length > g.length && beginnt(g, r.code); })) klopfer = [];
    };
    logo.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      klopfer.push(Date.now());
      logo.classList.remove('klopf-wackel'); void logo.offsetWidth; logo.classList.add('klopf-wackel');
      clearTimeout(auswertTimer); clearTimeout(resetTimer);
      auswertTimer = setTimeout(auswerten, RUHE);
      resetTimer = setTimeout(function () { klopfer = []; }, PAUSE_MAX + RUHE);
    });
    $$('[data-hinterzimmer-schliessen]', hinterzimmer).forEach(function (b) { b.addEventListener('click', function () { zeige(hinterzimmer, false); }); });
    bildAktionen({
      blatt: kartenBlatt,
      name: function () { return 'geheimrezept-' + offenesRezept.name.toLowerCase().replace(/[^a-z]+/g, '-') + '.png'; },
      titel: function () { return 'Geheimrezept: ' + offenesRezept.name; },
      text: function () { return 'Psst … das Geheimrezept ' + offenesRezept.name + ' aus der Flüsterkneipe. speakeasy-moonshine.de'; },
      speichern: $('[data-hinterzimmer-speichern]', hinterzimmer),
      teilen: $('[data-hinterzimmer-teilen]', hinterzimmer),
      kopieren: $('[data-hinterzimmer-kopieren]', hinterzimmer)
    });
  }

  /* ---------- Dein Deckel: Warenkorb als Bestellzettel aus der Flüsterkneipe ---------- */
  var rezept = $('[data-rezept]');
  if (rezept) {
    var blatt = $('[data-rezept-bild]', rezept);
    var zeichneRezept = function () {
      var korb = aktuellerKorb || { items: [] };
      var weihnachtlich = document.documentElement.hasAttribute('data-weihnacht');
      stift = blatt.getContext('2d');
      zettelGrund(weihnachtlich ? '★ FROHE WEIHNACHTEN ★' : '★ NUR FÜR EINGEWEIHTE ★', weihnachtlich ? '— Weihnachten in der Flüsterkneipe —' : '— Flüsterkneipe · Hinterzimmer —', weihnachtlich);
      // Tisch + Datum
      var heute = new Date();
      var datum = ('0' + heute.getDate()).slice(-2) + '.' + ('0' + (heute.getMonth() + 1)).slice(-2) + '.1926';
      var tisch = (heute.getDate() % 13) + 1;
      schreib('Tisch Nr. ' + tisch, 60, 205, 18, 'italic', TINTE);
      schreib(datum, 540, 205, 16, 'italic', TINTE, 'right');
      schreib('Dein Deckel', 60, 262, 34, 'italic bold', '#7a1f12');
      // Bestellung
      var y = 312;
      var posten = korb.items || [];
      if (!posten.length) { schreib('(noch nichts bestellt)', 80, y, 20, 'italic'); y += 40; }
      posten.slice(0, 7).forEach(function (item) {
        var name = anzeige(item).name;
        var zeile = item.quantity + ' × ' + name;
        stift.font = 'italic 23px ' + SERIF;
        while (stift.measureText(zeile).width > 330 && zeile.length > 4) zeile = zeile.slice(0, -2);
        schreib(zeile, 80, y, 23, 'italic', TINTE);
        // Strichliste wie auf einem echten Deckel
        stift.strokeStyle = TINTE; stift.lineWidth = 2;
        for (var i = 0; i < Math.min(item.quantity, 10); i++) {
          var x = 450 + (i % 5) * 9 + Math.floor(i / 5) * 55;
          stift.beginPath(); stift.moveTo(x, y - 18); stift.lineTo(x + 2, y + 2); stift.stroke();
          if (i % 5 === 4) { stift.beginPath(); stift.moveTo(x - 40, y - 2); stift.lineTo(x + 4, y - 14); stift.stroke(); }
        }
        y += 46;
      });
      if (posten.length > 7) schreib('… und noch mehr', 80, y, 18, 'italic', '#5a4428');
      zettelFuss(weihnachtlich);
    };
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-rezept-oeffnen]')) return;
      zeichneRezept();
      zeige(rezept, true);
    });
    bildAktionen({
      blatt: blatt,
      name: 'mein-deckel-speakeasy.png',
      titel: 'Mein Deckel im Speakeasy',
      text: 'Psst … mein Deckel aus der Flüsterkneipe 🥃 speakeasy-moonshine.de',
      speichern: $('[data-rezept-speichern]', rezept),
      teilen: $('[data-rezept-teilen]', rezept),
      kopieren: $('[data-rezept-kopieren]', rezept)
    });
    $$('[data-rezept-schliessen]', rezept).forEach(function (b) { b.addEventListener('click', function () { zeige(rezept, false); }); });
  }

  /* ---------- Tasting: „Die Zeche“ (Preisrechner) ---------- */
  var rechner = $('[data-abend-rechner]');
  if (rechner) {
    var personen = $('[data-rechner-personen]', rechner);
    var proPerson = Number(rechner.getAttribute('data-preis'));
    var MAX_PERSONEN = 10000;
    var rechne = function () {
      var n = Math.max(1, Math.min(MAX_PERSONEN, Math.round(Number(personen.value) || 1)));
      var zahl = function (x) { return x.toLocaleString('de-DE'); };
      $('[data-rechner-summe]', rechner).textContent = (n * proPerson / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
      $('[data-rechner-likoere]', rechner).textContent = zahl(n * 4);
      $('[data-rechner-wein]', rechner).textContent = zahl(n * 2);
      $('[data-rechner-cocktails]', rechner).textContent = zahl(n * 3);
      return n;
    };
    personen.addEventListener('input', rechne);
    personen.addEventListener('change', function () { personen.value = rechne(); });
    // − / + antippen oder gedrückt halten (zählt dann immer schneller weiter)
    var schritt = function (richtung) { personen.value = Math.max(1, Math.min(MAX_PERSONEN, rechne() + richtung)); rechne(); };
    [['[data-rechner-minus]', -1], ['[data-rechner-plus]', 1]].forEach(function (k) {
      var knopf = $(k[0], rechner), richtung = k[1], warte = null, wiederhole = null, zaehler = 0;
      var stopp = function () { clearTimeout(warte); clearTimeout(wiederhole); };
      var weiter = function (tempo) {
        zaehler += 1;
        schritt(richtung * (zaehler > 60 ? 100 : zaehler > 25 ? 10 : 1));
        wiederhole = setTimeout(function () { weiter(Math.max(40, tempo * 0.85)); }, tempo);
      };
      knopf.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        e.preventDefault();
        stopp();
        zaehler = 0;
        schritt(richtung);
        warte = setTimeout(function () { weiter(150); }, 400);
      });
      ['pointerup', 'pointerleave', 'pointercancel', 'blur'].forEach(function (t) { knopf.addEventListener(t, stopp); });
      knopf.addEventListener('contextmenu', function (e) { e.preventDefault(); });   // langes Drücken am Handy: kein Menü
      // Tastatur (Enter/Leertaste) löst nur „click“ ohne Zeiger aus
      knopf.addEventListener('click', function (e) { if (e.detail === 0) schritt(richtung); });
    });
    $('[data-rechner-uebernehmen]', rechner).addEventListener('click', function () {
      var feld = $('#tasting-formular [name="contact[Personen]"]');
      if (feld) feld.value = rechne();
    });
    rechne();
  }

  /* ---------- Tasting: Einladungskarte ---------- */
  var einladung = $('[data-einladung]');
  if (einladung) {
    var karte = $('[data-einladung-bild]', einladung);
    var pinselE = karte.getContext('2d');
    var SERIF_E = 'Georgia, "Times New Roman", serif';
    var GOLD_E = '#ffb900';
    var feld = function (n) { var f = $('[data-einladung-feld="' + n + '"]', einladung); return f ? f.value.trim() : ''; };
    // Farmer weiß mit dunklen Konturen: SVG holen, umfärben und als eigenes Bild laden (sonst ließe sich die Karte nicht speichern)
    var farmerBild = null;
    if (einladung.getAttribute('data-farmer') && window.fetch) {
      fetch(einladung.getAttribute('data-farmer')).then(function (r) { return r.ok ? r.text() : Promise.reject(); }).then(function (svg) {
        svg = svg.replace('fill="#2b1a0f"', 'fill="#0b0c10"').replace('fill="#d9c08f"', 'fill="#f4efe2"');
        var bild = new Image();
        bild.onload = function () {
          // Zeichnung auf ihren sichtbaren Teil zuschneiden, damit sie wirklich mittig sitzt
          var z = document.createElement('canvas'); z.width = 480; z.height = 800;
          var zc = z.getContext('2d'); zc.drawImage(bild, 0, 0, 480, 800);
          try {
            var d = zc.getImageData(0, 0, 480, 800).data, x0 = 480, x1 = 0, y0 = 800, y1 = 0;
            for (var y = 0; y < 800; y++) for (var x = 0; x < 480; x++) {
              if (d[(y * 480 + x) * 4 + 3] > 40) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
            }
            if (x1 > x0 && y1 > y0) { var k = document.createElement('canvas'); k.width = x1 - x0 + 1; k.height = y1 - y0 + 1; k.getContext('2d').drawImage(z, -x0, -y0); z = k; }
          } catch (e) {}
          farmerBild = z; zeichneEinladung();
        };
        bild.src = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));
      }).catch(function () {});
    }
    var zeile = function (t, y, groesse, stil, farbe, maxB) {
      var g = groesse;
      do { pinselE.font = (stil || 'normal') + ' ' + g + 'px ' + SERIF_E; g -= 1; } while (maxB && pinselE.measureText(t).width > maxB && g > 10);
      pinselE.fillStyle = farbe || '#e9e2cf';
      pinselE.textAlign = 'center';
      pinselE.fillText(t, 300, y);
    };
    // Weihnachten: Nikolausmütze für den Farmer
    var nikolausmuetze = function (c, x, y, b, dreh) {
      c.save(); c.translate(x, y); c.rotate(dreh); c.scale(b / 100, b / 100);
      c.lineJoin = 'round';
      c.beginPath(); c.moveTo(-44, 2); c.bezierCurveTo(-46, -36, -14, -72, 30, -56); c.bezierCurveTo(52, -48, 58, -22, 46, 2); c.closePath();
      c.fillStyle = '#c9232b'; c.fill(); c.strokeStyle = '#7a1015'; c.lineWidth = 3; c.stroke();
      c.beginPath(); c.moveTo(-30, -6); c.bezierCurveTo(-26, -34, -6, -52, 16, -54); c.strokeStyle = 'rgba(255,255,255,.28)'; c.lineWidth = 5; c.lineCap = 'round'; c.stroke();
      c.beginPath(); c.moveTo(-44, -8); c.lineTo(44, -8); c.arc(44, 4, 12, -Math.PI / 2, Math.PI / 2); c.lineTo(-44, 16); c.arc(-44, 4, 12, Math.PI / 2, Math.PI * 1.5);
      c.closePath(); c.fillStyle = '#fbfbff'; c.fill(); c.strokeStyle = '#c9c4b4'; c.lineWidth = 2; c.stroke();
      c.beginPath(); c.arc(40, -56, 14, 0, Math.PI * 2); c.fillStyle = '#fbfbff'; c.fill(); c.stroke();
      c.restore();
    };
    var zeichneEinladung = function () {
      var c = pinselE;
      var weihnachtlich = document.documentElement.hasAttribute('data-weihnacht');
      c.fillStyle = '#0b0c10'; c.fillRect(0, 0, 600, 850);
      var licht = c.createRadialGradient(300, 330, 40, 300, 330, 520);
      licht.addColorStop(0, 'rgba(255,185,0,.10)'); licht.addColorStop(1, 'rgba(0,0,0,0)');
      c.fillStyle = licht; c.fillRect(0, 0, 600, 850);
      if (weihnachtlich) {
        stift = c;
        // Schneetreiben im Hintergrund (feste Positionen, damit das Bild nicht flackert)
        var zufall = 7;
        for (var fi = 0; fi < 54; fi++) {
          zufall = (zufall * 9301 + 49297) % 233280; var fx = zufall / 233280 * 600;
          zufall = (zufall * 9301 + 49297) % 233280; var fy = zufall / 233280 * 850;
          c.beginPath(); c.arc(fx, fy, 1.2 + (fi % 3) * 0.9, 0, Math.PI * 2); c.fillStyle = 'rgba(255,255,255,' + (0.22 + (fi % 4) * 0.1).toFixed(2) + ')'; c.fill();
        }
        // Zuckerstangen-Rand
        var muster = document.createElement('canvas'); muster.width = muster.height = 28;
        var mk = muster.getContext('2d'); mk.fillStyle = '#fbfaf6'; mk.fillRect(0, 0, 28, 28);
        mk.strokeStyle = '#c9232b'; mk.lineWidth = 14;
        [-28, 0, 28].forEach(function (o) { mk.beginPath(); mk.moveTo(o, 28); mk.lineTo(o + 28, 0); mk.stroke(); });
        c.strokeStyle = c.createPattern(muster, 'repeat'); c.lineWidth = 12; c.strokeRect(6, 6, 588, 838);
      }
      // Art-Déco-Rahmen
      c.strokeStyle = GOLD_E; c.lineWidth = 3; c.strokeRect(24, 24, 552, 802);
      c.lineWidth = 1; c.strokeRect(36, 36, 528, 778);
      [[36, 36, 1, 1], [564, 36, -1, 1], [36, 814, 1, -1], [564, 814, -1, -1]].forEach(function (e) {
        c.beginPath(); c.moveTo(e[0], e[1] + 50 * e[3]); c.lineTo(e[0] + 22 * e[2], e[1] + 22 * e[3]); c.lineTo(e[0] + 50 * e[2], e[1]); c.stroke();
      });
      if (weihnachtlich) {
        stift = c;
        // Schneehaube oben am Rahmen, Schneewehe unten
        c.fillStyle = '#fbfdff';
        c.beginPath(); c.moveTo(36, 36); c.lineTo(564, 36); c.lineTo(564, 46);
        for (var ex = 564; ex > 36; ex -= 36) c.quadraticCurveTo(ex - 18, 58, Math.max(36, ex - 36), 46);
        c.closePath(); c.fill();
        for (ex = 58; ex < 550; ex += 54) { c.beginPath(); c.moveTo(ex - 4, 49); c.lineTo(ex, 61); c.lineTo(ex + 4, 49); c.fill(); }
        c.beginPath(); c.moveTo(36, 814); c.lineTo(36, 806);
        for (ex = 36; ex < 564; ex += 66) c.quadraticCurveTo(ex + 33, (ex / 66) % 2 ? 792 : 800, Math.min(564, ex + 66), 806);
        c.lineTo(564, 814); c.closePath(); c.fill();
        // Lichterkette direkt unter dem Schnee
        lichterkette(52, 58, 6, 83, '#2c5a3b');
        // Tannenkranz hinter dem Farmer
        for (var w = 0; w < 64; w++) {
          var a = w / 64 * Math.PI * 2;
          c.save(); c.translate(300 + Math.cos(a) * 92, 180 + Math.sin(a) * 92); c.rotate(a + (w % 2 ? 0.7 : -0.7));
          c.fillStyle = ['#2e7d4f', '#3f9a64', '#226b42'][w % 3]; c.beginPath(); c.ellipse(0, 0, 15, 5.5, 0, 0, Math.PI * 2); c.fill(); c.restore();
        }
        for (w = 0; w < 16; w++) {
          var b2 = w / 16 * Math.PI * 2 + 0.2;
          c.beginPath(); c.arc(300 + Math.cos(b2) * 95, 180 + Math.sin(b2) * 95, 4.2, 0, Math.PI * 2); c.fillStyle = '#d6232a'; c.fill();
          c.beginPath(); c.arc(298.8 + Math.cos(b2) * 95, 178.8 + Math.sin(b2) * 95, 1.3, 0, Math.PI * 2); c.fillStyle = 'rgba(255,255,255,.6)'; c.fill();
        }
      }
      // leicht gedreht, weil der Farmer in der Zeichnung schräg steht
      if (farmerBild) { try { c.save(); c.translate(300, 180); c.rotate(5 * Math.PI / 180); var fh = 200, fb = fh * farmerBild.width / farmerBild.height; c.drawImage(farmerBild, -fb / 2, -fh / 2, fb, fh); c.restore(); } catch (e) {} }
      if (weihnachtlich) {
        if (farmerBild) nikolausmuetze(c, 303, 100, 78, 0.1);
        stechpalme(60, 50, -0.7, 1.0); stechpalme(540, 50, 0.7, 1.0); stechpalme(58, 800, 2.6, .9); stechpalme(542, 800, -2.6, .9);
      }
      zeile('★ PSST … DU BIST EINGELADEN ★', 320, 15, 'bold', GOLD_E);
      zeile('TASTING', 386, 64, 'bold', '#ffffff');
      zeile(weihnachtlich ? 'Weihnachtsedition' : 'at Home', 430, weihnachtlich ? 36 : 40, 'italic', weihnachtlich ? '#ff7a6b' : GOLD_E, 470);
      c.fillStyle = GOLD_E; c.fillRect(160, 452, 280, 1.5);
      var gastgeber = feld('gastgeber');
      zeile(gastgeber ? 'bei ' + gastgeber : 'bei uns zu Hause', 490, 30, 'italic', '#e9e2cf', 470);
      var d = feld('datum'), datum = '';
      if (d) { var t = d.split('-'); datum = t[2] + '.' + t[1] + '.' + t[0]; }
      var uhr = feld('uhrzeit');
      zeile((datum || 'TT.MM.JJJJ') + (uhr ? '  ·  ' + uhr + ' Uhr' : ''), 540, 30, 'bold', '#ffffff', 470);
      var ort = feld('ort');
      if (ort) zeile(ort, 572, 20, 'italic', '#bdb59f', 470);
      zeile(weihnachtlich ? 'Liköre probieren · Cocktails mixen · Plätzchen naschen' : 'Liköre probieren · Cocktails mixen · gute Leute', 614, 17, 'normal', '#bdb59f', 480);
      // Parole
      c.strokeStyle = 'rgba(255,185,0,.6)'; c.setLineDash([6, 5]); c.strokeRect(110, 640, 380, 84); c.setLineDash([]);
      zeile('PAROLE AN DER TÜR', 666, 13, 'bold', GOLD_E);
      zeile('„' + (feld('parole') || (weihnachtlich ? 'Stille Nacht.' : 'Legal Gut.')) + '“', 706, 32, 'italic bold', '#ffffff', 350);
      zeile('Nur für Gäste ab 18 Jahren', 760, 13, 'normal', '#8a8577');
      zeile('SPEAKEASY MOONSHINE', 788, 14, 'bold', GOLD_E);
    };
    $$('[data-einladung-feld]', einladung).forEach(function (f) { f.addEventListener('input', zeichneEinladung); f.addEventListener('change', zeichneEinladung); });
    bildAktionen({
      blatt: karte,
      name: 'einladung-tasting.png',
      titel: 'Einladung: Tasting at Home',
      text: 'Psst … du bist eingeladen! 🥃',
      speichern: $('[data-einladung-speichern]', einladung),
      teilen: $('[data-einladung-teilen]', einladung),
      kopieren: $('[data-einladung-kopieren]', einladung)
    });
    if (document.documentElement.hasAttribute('data-weihnacht')) {
      var paroleFeld = $('[data-einladung-feld="parole"]', einladung);
      if (paroleFeld && paroleFeld.value === 'Legal Gut.') paroleFeld.value = 'Stille Nacht.';
    }
    zeichneEinladung();
  }

  /* ---------- Über uns: Mitgliedsausweis von der Schreibmaschine ---------- */
  var ausweis = $('[data-ausweis]');
  if (ausweis) {
    var blattA = $('[data-ausweis-bild]', ausweis);
    var cA = blattA.getContext('2d');
    var MONO = '"Courier New", Courier, monospace';
    var SERIF_A = 'Georgia, "Times New Roman", serif';
    var tippTimer = null, audio = null, ausweisFoto = null, fertigeZeilen = null;
    var klack = function () {
      if (!$('[data-ausweis-ton]', ausweis).checked) return;
      try {
        audio = audio || new (window.AudioContext || window.webkitAudioContext)();
        var dauer = 0.03, puffer = audio.createBuffer(1, audio.sampleRate * dauer, audio.sampleRate), daten = puffer.getChannelData(0);
        for (var i = 0; i < daten.length; i++) daten[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / daten.length, 4);
        var quelle = audio.createBufferSource(), laut = audio.createGain();
        quelle.buffer = puffer; laut.gain.value = 0.25;
        quelle.connect(laut); laut.connect(audio.destination); quelle.start();
      } catch (e) {}
    };
    var mitgliedsnummer = function (name) {
      var h = 7;
      for (var i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % 10000;
      return '1926-' + ('000' + h).slice(-4);
    };
    var karteGrund = function () {
      var weihnachtlich = document.documentElement.hasAttribute('data-weihnacht');
      stift = cA;   // gemeinsame Zeichenhelfer (Flocken, Stechpalme, Lichterkette) malen auf den Ausweis
      cA.fillStyle = '#efe2c2'; cA.fillRect(0, 0, 800, 500);
      var rand = cA.createRadialGradient(400, 250, 160, 400, 250, 520);
      rand.addColorStop(0, 'rgba(0,0,0,0)'); rand.addColorStop(1, 'rgba(90,60,25,.5)');
      cA.fillStyle = rand; cA.fillRect(0, 0, 800, 500);
      if (weihnachtlich) {
        // Zuckerstangen-Rand und ein paar Schneeflocken im Papier
        var muster = document.createElement('canvas'); muster.width = muster.height = 28;
        var mk = muster.getContext('2d'); mk.fillStyle = '#fbfaf6'; mk.fillRect(0, 0, 28, 28);
        mk.strokeStyle = '#c9232b'; mk.lineWidth = 14;
        [-28, 0, 28].forEach(function (o) { mk.beginPath(); mk.moveTo(o, 28); mk.lineTo(o + 28, 0); mk.stroke(); });
        cA.strokeStyle = cA.createPattern(muster, 'repeat'); cA.lineWidth = 12; cA.strokeRect(6, 6, 788, 488);
        flocke(244, 132, 11); flocke(768, 300, 13); flocke(560, 462, 11);
      }
      cA.strokeStyle = '#a8781c'; cA.lineWidth = 3; cA.strokeRect(16, 16, 768, 468);
      cA.lineWidth = 1; cA.strokeRect(26, 26, 748, 448);
      // Kopfzeile (Weihnachten: tiefrot, mit Schnee obenauf und Lichterkette darunter)
      if (weihnachtlich) {
        var band = cA.createLinearGradient(0, 26, 0, 96);
        band.addColorStop(0, '#8e1820'); band.addColorStop(1, '#5a0d12');
        cA.fillStyle = band;
      } else cA.fillStyle = '#2b2118';
      cA.fillRect(26, 26, 748, 70);
      cA.fillStyle = '#ffb900'; cA.textAlign = 'center';
      cA.font = 'bold 34px ' + SERIF_A; cA.fillText('SPEAKEASY MOONSHINE', 400, 68);
      cA.font = 'bold 13px ' + SERIF_A; cA.fillText(weihnachtlich ? '★  WEIHNACHTSAUSWEIS DER FLÜSTERKNEIPE  ★' : '★  MITGLIEDSAUSWEIS DER FLÜSTERKNEIPE  ★', 400, 88);
      if (weihnachtlich) {
        cA.fillStyle = '#fbfdff';
        cA.beginPath(); cA.moveTo(26, 26); cA.lineTo(774, 26); cA.lineTo(774, 33);
        for (var sx = 774; sx > 26; sx -= 34) cA.quadraticCurveTo(sx - 17, 41, Math.max(26, sx - 34), 33);
        cA.closePath(); cA.fill();
        for (sx = 52; sx < 760; sx += 61) { cA.beginPath(); cA.moveTo(sx - 3.5, 35); cA.lineTo(sx, 43); cA.lineTo(sx + 3.5, 35); cA.fill(); }
        cA.strokeStyle = 'rgba(140,165,205,.55)'; cA.lineWidth = 1;
        cA.beginPath(); cA.moveTo(774, 33); for (sx = 774; sx > 26; sx -= 34) cA.quadraticCurveTo(sx - 17, 41, Math.max(26, sx - 34), 33); cA.stroke();
        stechpalme(40, 32, -0.5, .8); stechpalme(760, 32, 0.5, .8);
        lichterkette(46, 97, 9, 79, '#1d3b26');
      }
      // Foto-Feld: eigenes Bild (alt getönt) oder Silhouette (Weihnachten mit Nikolausmütze)
      cA.fillStyle = '#d8c79f'; cA.fillRect(56, 126, 170, 210);
      if (ausweisFoto) {
        var fb = 170, fh = 210, q = Math.max(fb / ausweisFoto.width, fh / ausweisFoto.height);
        var sb = fb / q, sh = fh / q;
        cA.drawImage(ausweisFoto, (ausweisFoto.width - sb) / 2, (ausweisFoto.height - sh) / 2, sb, sh, 56, 126, fb, fh);
        // alt einfärben (Sepia) – von Hand, damit es auch in Safari funktioniert
        try {
          var px = cA.getImageData(56, 126, fb, fh), d = px.data;
          for (var i = 0; i < d.length; i += 4) {
            var r = d[i], g = d[i + 1], b = d[i + 2];
            d[i] = Math.min(255, (r * .393 + g * .769 + b * .189) * .95);
            d[i + 1] = Math.min(255, (r * .349 + g * .686 + b * .168) * .95);
            d[i + 2] = Math.min(255, (r * .272 + g * .534 + b * .131) * .95);
          }
          cA.putImageData(px, 56, 126);
        } catch (e) {}
      } else {
        cA.fillStyle = '#3b2c20';
        cA.beginPath(); cA.arc(141, 215, 38, 0, Math.PI * 2); cA.fill();
        cA.beginPath(); cA.moveTo(76, 336); cA.quadraticCurveTo(80, 262, 141, 262); cA.quadraticCurveTo(202, 262, 206, 336); cA.fill();
        if (weihnachtlich) {
          cA.fillStyle = '#b3202a';
          cA.beginPath(); cA.moveTo(100, 190); cA.bezierCurveTo(102, 150, 140, 128, 176, 140); cA.bezierCurveTo(196, 146, 206, 158, 204, 170); cA.lineTo(186, 190); cA.closePath(); cA.fill();
          cA.fillStyle = '#f7f2e6';
          cA.beginPath(); cA.moveTo(98, 182); cA.lineTo(184, 182); cA.arc(184, 190, 8, -Math.PI / 2, Math.PI / 2); cA.lineTo(98, 198); cA.arc(98, 190, 8, Math.PI / 2, Math.PI * 1.5); cA.fill();
          cA.beginPath(); cA.arc(204, 172, 10, 0, Math.PI * 2); cA.fill();
        } else {
          cA.beginPath(); cA.ellipse(141, 182, 60, 9, 0, 0, Math.PI * 2); cA.fill();
          cA.fillRect(110, 152, 62, 30);
        }
      }
      cA.strokeStyle = '#2b2118'; cA.lineWidth = 2; cA.strokeRect(56, 126, 170, 210);
      // Lochung
      cA.fillStyle = '#0b0c10'; cA.beginPath(); cA.arc(740, 70, 9, 0, Math.PI * 2); cA.fill();
      // Linien für die getippten Angaben
      cA.strokeStyle = 'rgba(43,33,24,.35)'; cA.lineWidth = 1;
      [176, 226, 276, 326].forEach(function (y) { cA.beginPath(); cA.moveTo(400, y + 8); cA.lineTo(740, y + 8); cA.stroke(); });
      cA.fillStyle = '#6b5236'; cA.textAlign = 'left'; cA.font = 'bold 12px ' + SERIF_A;
      ['NAME', 'MITGLIED NR.', 'MITGLIED SEIT', 'ZUTRITT'].forEach(function (t, i) { cA.fillText(t, 260, 176 + i * 50); });
      cA.font = 'italic 12px ' + SERIF_A; cA.fillStyle = '#6b5236'; cA.textAlign = 'left';
      cA.fillText('Nur für Erwachsene ab 18 Jahren. Nicht übertragbar.', 56, 472);
    };
    // Alle Klopfzeichen als Marken: Punkte je Gruppe, darunter der Name des Geheimrezepts
    var klopfzeichenLeiste = function (weihnachtlich) {
      var pille = function (x, y, b, h) {
        var r = h / 2;
        cA.beginPath(); cA.moveTo(x + r, y); cA.lineTo(x + b - r, y); cA.arc(x + b - r, y + r, r, -Math.PI / 2, Math.PI / 2);
        cA.lineTo(x + r, y + h); cA.arc(x + r, y + r, r, Math.PI / 2, Math.PI * 1.5); cA.closePath();
      };
      cA.textAlign = 'left'; cA.fillStyle = '#6b5236'; cA.font = 'bold 11px ' + SERIF_A;
      try { cA.letterSpacing = '2px'; } catch (e) {}
      cA.fillText('KLOPFZEICHEN AM LOGO', 56, 370);
      try { cA.letterSpacing = '0px'; } catch (e) {}
      var B = 150, H = 38, ABSTAND = 12;
      var farben = weihnachtlich ? ['#1d4a2e', '#7a1218', '#1d4a2e'] : ['#2b2118', '#2b2118', '#2b2118'];
      REZEPTE.forEach(function (r, i) {
        var x = 56 + i * (B + ABSTAND), y = 380;
        cA.save(); cA.shadowColor = 'rgba(40,25,10,.35)'; cA.shadowBlur = 6; cA.shadowOffsetY = 2;
        pille(x, y, B, H); cA.fillStyle = farben[i]; cA.fill(); cA.restore();
        pille(x + 1.5, y + 1.5, B - 3, H - 3); cA.strokeStyle = 'rgba(255,185,0,.55)'; cA.lineWidth = 1; cA.stroke();
        // Punkte: 12 px Abstand in der Gruppe, Pause als Lücke mit feinem Strich
        var PUNKT = 14, LUECKE = 22;
        var breite = r.code.reduce(function (s, n) { return s + (n - 1) * PUNKT; }, 0) + (r.code.length - 1) * LUECKE;
        var px = x + B / 2 - breite / 2;
        r.code.forEach(function (n, gi) {
          for (var k = 0; k < n; k++) {
            cA.save(); cA.shadowColor = 'rgba(255,185,0,.8)'; cA.shadowBlur = 5;
            cA.beginPath(); cA.arc(px, y + H / 2, 5.4, 0, Math.PI * 2); cA.fillStyle = '#ffc933'; cA.fill(); cA.restore();
            if (k < n - 1) px += PUNKT;
          }
          if (gi < r.code.length - 1) {
            cA.strokeStyle = 'rgba(255,185,0,.45)'; cA.lineWidth = 1;
            cA.beginPath(); cA.moveTo(px + LUECKE / 2, y + 12); cA.lineTo(px + LUECKE / 2, y + H - 12); cA.stroke();
            px += LUECKE;
          }
        });
        // Name des Rezepts
        // zu lange Namen in zwei Zeilen, getrennt an der Lücke nahe der Mitte
        var name = r.name.toUpperCase(), zeilen = [name];
        cA.font = 'bold 10px ' + SERIF_A;
        if (cA.measureText(name).width > B - 6) {
          var mitte = name.length / 2, schnitt = -1;
          for (var z = 0; z < name.length; z++) if ((name[z] === ' ' || name[z] === '-') && (schnitt < 0 || Math.abs(z - mitte) < Math.abs(schnitt - mitte))) schnitt = z;
          if (schnitt > 0) zeilen = [name.slice(0, name[schnitt] === '-' ? schnitt + 1 : schnitt), name.slice(schnitt + 1)];
        }
        cA.fillStyle = '#4a3826'; cA.textAlign = 'center';
        zeilen.forEach(function (t, zi) {
          var g = 10; cA.font = 'bold ' + g + 'px ' + SERIF_A;
          while (cA.measureText(t).width > B - 6 && g > 7) { g -= 0.5; cA.font = 'bold ' + g + 'px ' + SERIF_A; }
          cA.fillText(t, x + B / 2, y + H + 15 + zi * 12);
        });
      });
    };
    var stempel = function () {
      var weihnachtlich = document.documentElement.hasAttribute('data-weihnacht');
      klopfzeichenLeiste(weihnachtlich);   // erst sichtbar, wenn der Ausweis ausgestellt ist
      cA.save(); cA.translate(660, 414); cA.rotate(-0.2);
      cA.strokeStyle = 'rgba(160,30,30,.8)'; cA.fillStyle = 'rgba(160,30,30,.8)';
      cA.lineWidth = 3; cA.strokeRect(-100, -28, 200, 56); cA.lineWidth = 1.2; cA.strokeRect(-93, -21, 186, 42);
      cA.textAlign = 'center'; cA.font = 'bold 22px ' + SERIF_A; cA.fillText(weihnachtlich ? 'FROHES FEST' : 'GEPRÜFT', 0, 4);
      cA.font = 'bold 9px ' + SERIF_A; cA.fillText('★ DER BARKEEPER ★', 0, 17);
      cA.restore();
    };
    var zeilenFuer = function (name) {
      var heute = new Date();
      var datum = ('0' + heute.getDate()).slice(-2) + '.' + ('0' + (heute.getMonth() + 1)).slice(-2) + '.' + heute.getFullYear();
      return [
        { x: 400, y: 176, t: name.toUpperCase(), g: 26 },
        { x: 400, y: 226, t: mitgliedsnummer(name), g: 24 },
        { x: 400, y: 276, t: datum, g: 24 },
        { x: 400, y: 326, t: 'HINTERZIMMER ✓', g: 24 }
      ];
    };
    var zeichneBis = function (zeilen, anzahl) {
      karteGrund();
      cA.fillStyle = '#1d1a16'; cA.textAlign = 'left';
      var rest = anzahl;
      zeilen.forEach(function (z) {
        if (rest <= 0) return;
        var teil = z.t.slice(0, rest);
        rest -= z.t.length;
        cA.font = 'bold ' + z.g + 'px ' + MONO;
        cA.fillText(teil, z.x, z.y);
      });
    };
    var gesamt = function (zeilen) { return zeilen.reduce(function (s, z) { return s + z.t.length; }, 0); };
    var tippe = function () {
      var name = ($('[data-ausweis-name]', ausweis).value || '').trim() || 'Eingeweihte*r';
      var zeilen = zeilenFuer(name), n = 0, max = gesamt(zeilen);
      clearInterval(tippTimer);
      $('[data-ausweis-aktionen]', ausweis).hidden = true;
      fertigeZeilen = null;
      if (ruhig) { zeichneBis(zeilen, max); stempel(); fertigeZeilen = zeilen; $('[data-ausweis-aktionen]', ausweis).hidden = false; return; }
      tippTimer = setInterval(function () {
        n += 1;
        zeichneBis(zeilen, n);
        var zeichen = (zeilen.map(function (z) { return z.t; }).join(''))[n - 1];
        if (zeichen && zeichen !== ' ') klack();
        if (n >= max) {
          clearInterval(tippTimer);
          setTimeout(function () { stempel(); fertigeZeilen = zeilen; $('[data-ausweis-aktionen]', ausweis).hidden = false; }, 250);
        }
      }, 38);
    };
    $('[data-ausweis-tippen]', ausweis).addEventListener('click', tippe);
    $('[data-ausweis-name]', ausweis).addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); tippe(); } });
    bildAktionen({
      blatt: blattA,
      name: 'mitgliedsausweis-speakeasy.png',
      titel: 'Mein Speakeasy-Mitgliedsausweis',
      text: 'Psst … ich bin jetzt Mitglied der Flüsterkneipe 🥃 speakeasy-moonshine.de',
      speichern: $('[data-ausweis-speichern]', ausweis),
      teilen: $('[data-ausweis-teilen]', ausweis),
      kopieren: $('[data-ausweis-kopieren]', ausweis)
    });
    var ladeFoto = function (datei) {
      if (!datei || !/^image\//.test(datei.type)) return;
      var bild = new Image();
      var adresse = URL.createObjectURL(datei);
      bild.onload = function () {
        URL.revokeObjectURL(adresse);   // Datei sofort wieder freigeben – das Foto lebt nur noch auf der Karte
        ausweisFoto = bild;
        if (fertigeZeilen) { zeichneBis(fertigeZeilen, gesamt(fertigeZeilen)); stempel(); }
        else karteGrund();
      };
      bild.src = adresse;   // bleibt im Browser, wird nirgends hochgeladen oder gespeichert
    };
    $('[data-ausweis-foto]', ausweis).addEventListener('change', function (e) { ladeFoto(e.target.files && e.target.files[0]); });
    // Am PC: Foto einfach auf das Feld oder den Ausweis ziehen
    [$('[data-ausweis-ablage]', ausweis), blattA].forEach(function (ziel) {
      ['dragenter', 'dragover'].forEach(function (typ) {
        ziel.addEventListener(typ, function (e) { e.preventDefault(); ziel.classList.add('ablage-aktiv'); });
      });
      ['dragleave', 'drop'].forEach(function (typ) {
        ziel.addEventListener(typ, function () { ziel.classList.remove('ablage-aktiv'); });
      });
      ziel.addEventListener('drop', function (e) {
        e.preventDefault();
        ladeFoto(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]);
      });
    });
    karteGrund();   // leere Karte als Vorschau
  }

  /* ---------- Escape schließt das oberste Overlay ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (rezept && !rezept.hidden) return zeige(rezept, false);
    if (hinterzimmer && !hinterzimmer.hidden) return zeige(hinterzimmer, false);
    var siegFenster = $('[data-jagd-sieg]');
    if (siegFenster && !siegFenster.hidden) return zeige(siegFenster, false);
    if (jagd && !jagd.hidden) return zeige(jagd, false);
    if (bildansicht && !bildansicht.hidden) return zeige(bildansicht, false);
    if (mixbox && !mixbox.hidden) return zeige(mixbox, false);
    if (leiste && !leiste.hidden) return zeige(leiste, false);
  });

  /* ---------- Von Shopify gelieferte Seiten (z. B. Newsletter-Bestätigung) aufräumen ---------- */
  var systemseite = $('[data-systemseite]');
  if (systemseite) {
    var inhalt = systemseite.textContent;   // vor dem Umschreiben merken
    var gehe = document.createTreeWalker(systemseite, NodeFilter.SHOW_TEXT), knoten, weg = [];
    while ((knoten = gehe.nextNode())) {
      var t = knoten.nodeValue.trim();
      // Shopname steht schon oben in der Kopfzeile, der Abmelde-Satz doppelt den Abmelde-Link
      if (t === 'Speakeasy Moonshine' || /jederzeit wieder abmelden/i.test(t)) weg.push(knoten);
      else if (/von unserer Mailingliste abgemeldet/i.test(t)) knoten.nodeValue = 'Du bist von der Gästeliste gestrichen. Ab jetzt flüstern wir dir nichts mehr zu, versprochen.';
      else if (/keine Marketing-Updates/i.test(t)) knoten.nodeValue = 'Falls dir die Stille irgendwann zu laut wird: Unten im Geheimtipp-Kasten kannst du dich jederzeit wieder eintragen.';
      else if (/jederzeit wieder anmelden/i.test(t)) weg.push(knoten);
      else if (/für unsere Mailingliste angemeldet/i.test(t)) knoten.nodeValue = 'Du stehst jetzt auf der Gästeliste. Ab sofort flüstern wir dir neue Sorten, geheime Aktionen und Tasting-Termine zu, bevor es jemand anderes erfährt.';
    }
    weg.forEach(function (k) {
      var el = k.parentNode;
      k.remove();
      // Zeilenumbruch direkt danach mit entfernen, damit keine Lücke bleibt
      while (el && el !== systemseite && !el.textContent.trim() && !el.querySelector('a,img,input,button')) { var p = el.parentNode; el.remove(); el = p; }
    });
    $$('br', systemseite).forEach(function (br) {
      var vor = br.previousSibling;
      if (!vor || (vor.nodeType === 1 && vor.tagName === 'BR') || (vor.nodeType === 3 && !vor.nodeValue.trim() && (!vor.previousSibling || vor.previousSibling.tagName === 'BR'))) br.remove();
    });
    var inhaltFeld = $('[data-systemseite-inhalt]', systemseite);
    // Abmelde-Link von Shopify wird zum zweiten Knopf, der kleine Link verschwindet
    var abmeldeKnopf = $('[data-systemseite-abmelden]', systemseite);
    $$('a', inhaltFeld).forEach(function (a) {
      if (!/abmelden|abbestellen|unsubscribe/i.test(a.textContent)) return;
      if (abmeldeKnopf.hidden) { abmeldeKnopf.href = a.href; abmeldeKnopf.hidden = false; }
      a.remove();
    });
    // Nach der Anmeldung ein Gruß als Überschrift (nicht nach dem Abmelden)
    if (/angemeldet|abonniert/i.test(inhalt) && !/abgemeldet|abbestellt/i.test(inhalt)) {
      var gruss = document.createElement('h1');
      gruss.className = 'mb-6 font-serif text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-6xl light:text-neutral-900';
      gruss.innerHTML = 'Willkommen unter den <span class="text-amber-400">Eingeweihten.</span>';
      inhaltFeld.prepend(gruss);
    } else if (/abgemeldet|abbestellt/i.test(inhalt)) {
      var abschied = document.createElement('h1');
      abschied.className = 'mb-6 font-serif text-4xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-6xl light:text-neutral-900';
      abschied.innerHTML = 'Die Tür bleibt <span class="text-amber-400">angelehnt.</span>';
      inhaltFeld.prepend(abschied);
      $('[data-systemseite-fuss]', systemseite).remove();   // Vorteile-Zeile passt nach dem Abmelden nicht mehr
    }
  }

  ladeKorb();
})();
